import { delay, http, HttpResponse } from 'msw';

import { CandidateDto } from '@/entities/candidate';
import { BestMatchesDto } from '../../model';

export const bestMatchesInfiniteQueryMocked = http.get<{ id: string }>(
  '/api/chat/:id/best-matches',
  async ({ request, params }) => {
    const url = new URL(request.url);
    const searchParams = url.searchParams;

    const chatId = params.id;
    const offset = parseInt(searchParams.get('offset') || '0');
    const limit = parseInt(searchParams.get('limit') || '5');

    const page: BestMatchesDto = JSON.parse(JSON.stringify(bestMatchesResponse));
    const candidates = page.search_results.hits.hits.splice(0);
    const candidatesPage = candidates.slice(offset, limit);

    page.id = parseInt(chatId);
    page.search_results.hits.hits = candidatesPage;

    await delay(offset === 0 ? 2000 : 1000);

    return HttpResponse.json<BestMatchesDto>(page);
  },
);

export const bestMatchesInfiniteQueryMockedEmpty = http.get<{ id: string }>(
  '/api/chat/:id/best-matches',
  async ({ params }) => {
    const chatId = params.id;

    const page: BestMatchesDto = JSON.parse(JSON.stringify(bestMatchesResponse));
    page.id = parseInt(chatId);
    page.search_results.hits.hits = [];
    page.search_results.hits.total.value = 0;

    await delay(2000);

    return HttpResponse.json<BestMatchesDto>(page);
  },
);

const bestMatchesResponse: BestMatchesDto = {
  id: 321321,
  total_candidates_count: 154,
  new_candidates_count: 0,
  approved_candidates_count: 0,
  rejected_candidates_count: 0,
  rated_candidates_count: 0,
  last_viewed: '2025-11-07T17:12:10.909057Z',
  last_synced: '2025-11-07T17:07:46.977466Z',
  vacancy_url: null,
  job_improved: null,
  user: {
    full_name: 'Gabriel G',
    initials: 'GG',
  },
  rated_candidates: [],
  current_filter: {
    filters: {
      ignore_experience_older_than_months: 420,
      full: [],
      job_titles: [
        {
          key: 'Logistiek Medewerker',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: false,
          current_jobs_only: false,
        },
        {
          key: 'orderpicker',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'warehouse*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'expediti*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'order pick*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'logisti*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'warehouse employee',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'logistics employee',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'warehouse worker',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'logistiek medewerker dagdienst',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'order picker',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'expeditiemedewerker',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'magazijnmedewerker',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'magazijn*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'warehouse medewerker',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: 'orderpick*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: false,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*vice president*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*head*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*direct*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*coördinator*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*lead*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*chef*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*supervis*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*hoofd*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*voorman*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*beheerder*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*leid*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*zzp*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*vp of*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*manage*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*freelanc*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*coordinator*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
        {
          key: '*interim*',
          min_experience_months: 0,
          max_experience_months: 0,
          exclude: true,
          must: false,
          isSynonym: true,
          current_jobs_only: false,
        },
      ],
      languages: [],
      skills: [],
      keywords: [],
      total_experience: {},
      locations: [
        {
          key: 'Pernis',
          exclude: false,
          distance: '20km',
          lat: 51.8946,
          lon: 4.4199,
          isAiCreated: false,
        },
      ],
      companies: [],
      schools: [],
      education_degrees: [
        {
          key: 'LBO',
          exclude: false,
          current: false,
          must: false,
          isAiCreated: false,
        },
        {
          key: 'MBO',
          exclude: false,
          current: false,
          must: false,
          isAiCreated: false,
        },
        {
          key: 'middelbaar beroepsonderwijs',
          exclude: false,
          current: false,
          must: false,
          isAiCreated: true,
        },
        {
          key: 'Meao',
          exclude: false,
          current: false,
          must: false,
          isAiCreated: true,
        },
        {
          key: 'MTS',
          exclude: false,
          current: false,
          must: false,
          isAiCreated: true,
        },
      ],
      education_fields: [],
      graduation_year: {
        min_months: 0,
        max_months: 0,
      },
      industries: [],
      profile_ids: [],
      linkedin_usernames: [],
      default_location: {
        lat: 52.3667,
        lon: 4.8945,
      },
      title_classification: [],
      sources: [
        'ats',
        'cvt',
        'debanensite',
        'indeed',
        'jobbird',
        'monsterboard_v2',
        'nvb',
        'resumeio',
        'robin_resume',
        'studentjob',
        'techniekwerkt',
        'uitzendbureau',
        'werknl',
      ],
      has_email: false,
      has_phone: false,
      has_insight: false,
      updated_at: {
        key: '-1m',
        gte: 'now-1M',
      },
      changed_at: {
        key: 'any',
      },
      sort_by: 'score',
      employment_type_preference: 'any',
      job_title_type: 'all',
      ats_name: 'otys',
      tenant_id: '2512',
      user_id: '16125',
      hide_candidates_statuses: ['MATCHED', 'HIDDEN'],
      hide_candidates_period: 30,
      campaign_origin: 'text',
      campaign_id: null,
    },
    created_at: '2025-11-07T17:07:46.881061Z',
    updated_at: '2025-11-07T17:07:46.881091Z',
  },
  search_results: {
    took: 1409,
    timed_out: false,
    _shards: {
      total: 1,
      successful: 1,
      skipped: 0,
      failed: 0,
    },
    hits: {
      total: {
        value: 20,
        relation: 'eq',
      },
      max_score: 28.909346,
      hits: [
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-7538879',
          _score: 12.935383,
          _source: {
            id: 7538879,
            source: 'werknl',
            name: 'Jo-Anne Tinisha Cristina Daal Hooi',
            headline: 'medewerker fastfoodrestaurant',
            description:
              "Ik ben een betrouwbare en gemotiveerde teamspeler met een sportieve instelling en ervaring in een dynamische werkomgeving. Dankzij mijn achtergrond in sport en beweging ben ik gewend om actief bezig te zijn, samen te werken en verantwoordelijkheid te nemen. Ik werk nauwkeurig, help graag collega's en vind het belangrijk dat taken goed en op tijd worden uitgevoerd. Met mijn doorzettingsvermogen en leergierige houding wil ik mezelf verder ontwikkelen binnen de logistieke sector.",
            experiences: {
              jobs: [
                {
                  role: 'medewerker fastfoodrestaurant',
                  employment_hours: 20,
                  description:
                    'Ik was verantwoordelijk voor het opnemen van bestellingen, bereiden van maaltijden, bedienen van klanten en het schoonmaken van de werkruimte.',
                  company: {
                    name: 'KFC',
                  },
                  dates: {
                    start: {
                      month: 5,
                      year: 2024,
                    },
                    end: {
                      month: 12,
                      year: 2024,
                    },
                    end_recalculated: 24300,
                    start_recalculated: 24293,
                  },
                },
                {
                  role: 'medewerker fastfoodrestaurant',
                  employment_hours: 38,
                  description:
                    'Ik werkte in teamverband om gasten snel en vriendelijk te bedienen, bereidde bestellingen en zorgde voor een schone werkomgeving.',
                  company: {
                    name: 'Mc Donalds',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2025,
                    },
                    end: {
                      month: 8,
                      year: 2025,
                    },
                    end_recalculated: 24308,
                    start_recalculated: 24301,
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'sport en recreatie',
                  },
                  degree: 'sport- en bewegingsbegeleider (mbo-2)',
                  dates: {
                    start: {
                      month: 2,
                      year: 2023,
                    },
                    end: {
                      month: 1,
                      year: 2025,
                    },
                    end_recalculated: 24301,
                    start_recalculated: 24278,
                  },
                  obtainedDegree: true,
                },
              ],
              skills: [
                {
                  europass: null,
                  name: 'Aandacht voor anderen',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Samenwerken en overleggen',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Betrouwbaar en eerlijk zijn',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Logisch nadenken',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Leren',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Plannen en organiseren',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Klantgericht werken',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Kwaliteit leveren',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Werken volgens de regels',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Succesvol willen zijn',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Omgaan met spanning en tegenslag',
                  description: null,
                },
              ],
              certifications: [],
              languages: [
                {
                  proficiencyWritten: 'fluent',
                  name: 'Nederlands',
                  proficiency: 'fluent',
                },
                {
                  proficiencyWritten: 'excellent',
                  name: 'Papiamento',
                  proficiency: 'excellent',
                },
                {
                  proficiencyWritten: 'excellent',
                  name: 'Spaans',
                  proficiency: 'excellent',
                },
                {
                  proficiencyWritten: 'excellent',
                  name: 'Engels',
                  proficiency: 'excellent',
                },
              ],
            },
            licenses: [
              {
                name: 'B',
                type: 'driving_license_code',
              },
            ],
            interests: [
              {
                name: 'Sport',
                description: null,
              },
              {
                name: 'Film',
                description: null,
              },
              {
                name: 'Muziek luisteren',
                description: null,
              },
            ],
            contact_info: {
              email: ['jowiehooi@gmail.com'],
              phone: ['0613139566'],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/7538879'],
            },
            location: {
              exists: true,
              raw: 'Rotterdam',
              coordinates: {
                lat: 51.91837143333334,
                lon: 4.432997197101449,
              },
              city: {
                short_name: 'Rotterdam',
                long_name: 'Rotterdam',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: 'Delfshaven',
                  long_name: 'Delfshaven',
                },
              },
              postal_code: '3027ET',
              address: 'Rotterdam',
              place_id: 11607160,
              aggregate: ['Rotterdam', 'Zuid-Holland', 'Delfshaven', 'Nederland', 'NL'],
            },
            sourceMeta: {
              updatedAt: '2025-11-07T07:11:08.970Z',
              changedAt: '2025-11-07T07:20:18.440Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-07T07:20:18.428Z',
            },
            preferences: {
              jobTitles: [
                'Orderpicker, Orderpicker ',
                'Heftruckchauffeur, Heftruckchauffeur ',
                'Productiemedewerker, Productiemedewerker ',
              ],
              workHours: {
                min: 36,
                max: 40,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 5,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 24278,
                  last: 24301,
                  gap: 0,
                },
                professional: {
                  first: 24293,
                  last: 24308,
                  gap: 1,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'medewerker fastfoodrestaurant',
            recent_job_titles: 'medewerker fastfoodrestaurant medewerker fastfoodrestaurant',
            past_job_titles: '',
            insights: [
              {
                createdAt: '2025-11-04T09:40:20.674Z',
                newValue: null,
                _id: '6909ca0406b0a545522b6169',
                oldValue: null,
                candidateId: 7538879,
                type: 'candidate.added',
                platform: 'werknl',
              },
            ],
            last_insight_date: '2025-11-04T09:40:20.674Z',
            new_candidate_date: '2025-11-04T09:40:20.674Z',
            robin_verified: true,
            communication_opt_out: false,
            robin_verified_metadata: {
              verified_at: '2025-11-04T11:05:12.222023',
              jobs: 'Heftruckchauffeur, Productiemedewerker',
              salary: '2500',
              travel_time: '45',
              working_hours_per_week: '32 - 40',
              available_days: 'Maandag, Dinsdag, Woensdag, Donderdag, Vrijdag',
              shifts: 'Alleen overdag',
              save_preferences: 'yes',
            },
          },
          sort: [1762254312222, 1762249220674],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 10,
              duration_minutes: 34,
            },
            driving: {
              distance_km: 18,
              duration_minutes: 18,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'uitzendbureau-911331',
          _score: 13.977221,
          _ignored: [
            'location.city.long_name.completion',
            'location.aggregate.completion',
            'experiences.jobs.role.completion',
            'experiences.educations.school.name.completion',
            'location.region.level2.long_name.completion',
            'experiences.jobs.company.name.completion',
          ],
          _source: {
            id: '911331',
            source: 'uitzendbureau',
            cvFileId: 'cv-74aa59bf9d412b016d4062d0eddcf808a7d8e0b7ead957f15cb89efb11a4393a.pdf',
            name: 'Lahcen',
            contact_info: {
              uitzendbureau: ['https://www.uitzendbureau.nl/login/kandidaat/911331'],
              phone: ['+316-85855853'],
              email: ['simpel67@gmail.com'],
            },
            licenses: [
              {
                name: 'truck',
                type: 'driving_license_name',
              },
              {
                name: 'car',
                type: 'driving_license_name',
              },
              {
                name: 'bus',
                type: 'driving_license_name',
              },
            ],
            location: {
              exists: true,
              raw: 'Kareldoormenlaan 100 3333am Zwijndrecht Nederland',
              coordinates: {
                lat: 51.80893217083334,
                lon: 4.633942224999999,
              },
              city: {
                short_name: '',
                long_name: '',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '3333AM',
              address: 'Zwijndrecht, Zuid-Holland, Nederland, 3333AM, Nederland',
              place_id: 11633338,
              aggregate: [null, 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            preferences: {
              jobTitles: ['Logistiek'],
              workHours: {
                min: 0,
                max: 40,
              },
              employmentType: ['part_time'],
              locations: ['Zwijndrecht'],
              availability: '2018-02-05T00:00:00.000Z',
            },
            experiences: {
              jobs: [
                {
                  company: {
                    name: '',
                  },
                  role: 'Magazijnmedewerker',
                  dates: {
                    start: {
                      month: 1,
                      year: 1985,
                    },
                    end: {
                      month: 1,
                      year: 1989,
                    },
                    start_recalculated: 23821,
                    end_recalculated: 23869,
                  },
                  description: '',
                },
                {
                  company: {
                    name: '',
                  },
                  role: 'Hijskraanmachinist',
                  dates: {
                    start: {
                      month: 1,
                      year: 1989,
                    },
                    end: {
                      month: 1,
                      year: 1999,
                    },
                    start_recalculated: 23869,
                    end_recalculated: 23989,
                  },
                  description: '',
                },
                {
                  company: {
                    name: '',
                  },
                  role: '',
                  dates: {
                    start: {
                      month: 1,
                      year: 1999,
                    },
                    end: {
                      month: 1,
                      year: 2003,
                    },
                    start_recalculated: 23989,
                    end_recalculated: 24037,
                  },
                  description: '',
                },
                {
                  company: {
                    name: '',
                  },
                  role: 'Chauffeur',
                  dates: {
                    start: {
                      month: 1,
                      year: 2007,
                    },
                    start_recalculated: 24085,
                  },
                  description:
                    'Besturen betonmixers binnen NL.; Bedienen van betonpompen; Besturen van vrachtwagens in binnen en buitenland.',
                },
              ],
              educations: [
                {
                  school: {
                    name: 'Lagere School (LO) Weiderhorizon, Zwijndrecht (Netherlands)',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 1980,
                    },
                    end: {
                      month: 1,
                      year: 1985,
                    },
                    start_recalculated: 23761,
                    end_recalculated: 23821,
                  },
                  degree: 'null ',
                },
                {
                  school: {
                    name: '',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 1991,
                    },
                    end: {
                      month: 1,
                      year: 1993,
                    },
                    start_recalculated: 23893,
                    end_recalculated: 23917,
                  },
                  degree: 'Nederlandse Schriftelijke en Mondelinge Taalbeheersing ',
                },
                {
                  school: {
                    name: 'Ijmuiden (Netherlands)',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 1994,
                    },
                    end: {
                      month: 1,
                      year: 1994,
                    },
                    start_recalculated: 23929,
                    end_recalculated: 23929,
                  },
                  degree: 'Kraanmachinist (MBO) & (Cursus) Van Leeuwen Buizen ',
                },
                {
                  school: {
                    name: 'Wierks, Zwijndrecht (Netherlands)',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 1999,
                    },
                    end: {
                      month: 1,
                      year: 1999,
                    },
                    start_recalculated: 23989,
                    end_recalculated: 23989,
                  },
                  degree: 'Vrachtwagenchauffeur (C) Opleiding ',
                },
                {
                  school: {
                    name: '',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2008,
                    },
                    end: {
                      month: 1,
                      year: 2008,
                    },
                    start_recalculated: 24097,
                    end_recalculated: 24097,
                  },
                  degree: 'VCA-B ',
                },
                {
                  school: {
                    name: 'Van Buuren, Pijnacker (Netherlands)',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2010,
                    },
                    end: {
                      month: 1,
                      year: 2010,
                    },
                    start_recalculated: 24121,
                    end_recalculated: 24121,
                  },
                  degree: 'Buschauffeur (D) ',
                },
                {
                  school: {
                    name: 'Van Buuren, Dordrecht (Netherlands)',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2010,
                    },
                    end: {
                      month: 1,
                      year: 2010,
                    },
                    start_recalculated: 24121,
                    end_recalculated: 24121,
                  },
                  degree: 'Vrachtwagenchauffeur (CE) ',
                },
              ],
              relocations: [],
              certifications: [],
              skills: [
                {
                  name: 'Mondelinge',
                },
                {
                  name: 'Page 1 / 2',
                },
                {
                  name: 'Page 2 / 2',
                },
              ],
              languages: [
                {
                  name: 'Arabisch',
                  proficiency: 'excellent',
                  proficiencyWritten: 'excellent',
                },
              ],
              honors: [],
              volunteer: [],
              licenses: [
                {
                  name: 'truck',
                  type: 'driving_license_name',
                },
                {
                  name: 'car',
                  type: 'driving_license_name',
                },
                {
                  name: 'bus',
                  type: 'driving_license_name',
                },
              ],
            },
            updatedDate: '2025-11-07T15:35:50.000Z',
            rr: {
              platform: 'uitzendbureau',
              updatedAt: '2025-11-07T15:36:05.917Z',
              updatedByCredentialUsername: 'roberto@recruitrobin.com',
              changedAt: '2025-11-07T15:36:05.932Z',
            },
            crawlerMeta: {
              platform: 'uitzendbureau',
              updatedAt: '2025-11-07T15:36:05.917Z',
              updatedByCredentialUsername: 'roberto@recruitrobin.com',
              changedAt: '2025-11-07T15:36:05.932Z',
            },
            sourceMeta: {
              updatedAt: '2025-11-07T15:35:50.000Z',
              changedAt: '2025-11-07T15:36:05.932Z',
            },
            description:
              'Lahcen Azoulaye heeft ervaring in:  Light Technical/Trades/Skilled Labor (Machine Shop; Maint and Repair); en Light Technical/Trades/Skilled Labor (Machine Shop). Lahcen Azoulaye heeft 38 jaar werkervaring.',
            headline: '',
            meta: {
              experience: {
                academic: {
                  first: 23761,
                  last: 24121,
                  gap: 276,
                },
                professional: {
                  first: 23821,
                  last: null,
                  gap: 48,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Chauffeur',
            recent_job_titles: 'Chauffeur ',
            past_job_titles: 'Magazijnmedewerker Hijskraanmachinist',
            insights: [
              {
                _id: '690e11e54bcee483fc8d7b74',
                createdAt: '2025-11-07T15:36:05.922Z',
                platform: 'uitzendbureau',
                candidateId: '911331',
                type: 'candidate.added',
                newValue: null,
                oldValue: null,
              },
            ],
            last_insight_date: '2025-11-07T15:36:05.922Z',
            new_candidate_date: '2025-11-07T15:36:05.922Z',
          },
          sort: [0, 1762529765922],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 21,
              duration_minutes: 67,
            },
            driving: {
              distance_km: 22,
              duration_minutes: 21,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-7502257',
          _score: 11.263465,
          _source: {
            id: 7502257,
            source: 'werknl',
            name: 'Aze-ddine Ayoub Bougoussa',
            headline: 'Magazijnmedewerker',
            description: null,
            experiences: {
              jobs: [
                {
                  role: 'lichtmatroos binnenvaart',
                  employment_hours: 40,
                  description: null,
                  dates: {
                    start: {
                      month: 3,
                      year: 2005,
                    },
                    end: {
                      month: 1,
                      year: 2007,
                    },
                    end_recalculated: 24085,
                    start_recalculated: 24063,
                  },
                },
                {
                  role: 'Glazenwasser',
                  employment_hours: 40,
                  description: null,
                  dates: {
                    start: {
                      month: 1,
                      year: 2008,
                    },
                    end: {
                      month: 9,
                      year: 2010,
                    },
                    end_recalculated: 24129,
                    start_recalculated: 24097,
                  },
                },
                {
                  role: 'Containermonteur',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'Swannis',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2019,
                    },
                    end: {
                      month: 6,
                      year: 2019,
                    },
                    end_recalculated: 24234,
                    start_recalculated: 24229,
                  },
                },
                {
                  role: 'constructiebankwerker/lasser',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'Ihc',
                  },
                  dates: {
                    start: {
                      month: 6,
                      year: 2019,
                    },
                    end: {
                      month: 11,
                      year: 2020,
                    },
                    end_recalculated: 24251,
                    start_recalculated: 24234,
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'Albeda College ',
                  },
                  degree: 'vmbo basisberoepsgerichte leerweg metaaltechniek (vbo)',
                  dates: {
                    start: {
                      month: 8,
                      year: 2003,
                    },
                    start_recalculated: 24044,
                  },
                  obtainedDegree: false,
                },
                {
                  school: {
                    name: 'Zadkine ',
                  },
                  degree: 'sport- en bewegingsbegeleider (mbo-2)',
                  dates: {
                    start: {
                      month: 9,
                      year: 2005,
                    },
                    end: {
                      month: 11,
                      year: 2006,
                    },
                    end_recalculated: 24083,
                    start_recalculated: 24069,
                  },
                  obtainedDegree: false,
                },
              ],
              skills: [],
              certifications: [
                {
                  name: 'booglassen mig/mag (niveau 1) (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 1,
                      year: 2019,
                    },
                  },
                },
              ],
              languages: [
                {
                  proficiencyWritten: 'fluent',
                  name: 'Nederlands',
                  proficiency: 'fluent',
                },
              ],
            },
            licenses: [],
            interests: [],
            contact_info: {
              email: ['aze_ddine@hotmail.com'],
              phone: ['0616511542'],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/7502257'],
            },
            location: {
              exists: true,
              raw: 'ROTTERDAM',
              coordinates: {
                lat: 51.91669717837837,
                lon: 4.47725781891892,
              },
              city: {
                short_name: 'Rotterdam',
                long_name: 'Rotterdam',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: 'Centrum',
                  long_name: 'Centrum',
                },
              },
              postal_code: '3012KM',
              address: 'ROTTERDAM',
              place_id: 11605432,
              aggregate: ['Rotterdam', 'Zuid-Holland', 'Centrum', 'Nederland', 'NL'],
            },
            sourceMeta: {
              updatedAt: '2025-11-07T13:30:10.147Z',
              changedAt: '2025-11-07T14:05:55.606Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-07T15:04:49.575Z',
            },
            preferences: {
              jobTitles: ['Magazijnmedewerker, Metaal operator ', 'Magazijnmedewerker, Lasser machine operator '],
              workHours: {
                min: 40,
                max: 40,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 10,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 24044,
                  last: null,
                  gap: 0,
                },
                professional: {
                  first: 24063,
                  last: 24251,
                  gap: 112,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'constructiebankwerker/lasser',
            recent_job_titles: 'constructiebankwerker/lasser Containermonteur',
            past_job_titles: 'lichtmatroos binnenvaart Glazenwasser',
            insights: [
              {
                createdAt: '2025-11-07T14:05:55.592Z',
                newValue: null,
                _id: '690dfcc3196afc22e5fcf816',
                oldValue: null,
                candidateId: 7502257,
                type: 'candidate.added',
                platform: 'werknl',
              },
            ],
            last_insight_date: '2025-11-07T14:05:55.592Z',
            new_candidate_date: '2025-11-07T14:05:55.592Z',
          },
          sort: [0, 1762524355592],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 9,
              duration_minutes: 29,
            },
            driving: {
              distance_km: 9,
              duration_minutes: 16,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'cvt-AEMAAAdOHz8Bl_KrjXK4CNPh0FT3UMbmEb8Gew0',
          _score: 11.944925,
          _ignored: ['location.aggregate.completion', 'location.region.level2.long_name.completion'],
          _source: {
            id: 'AEMAAAdOHz8Bl_KrjXK4CNPh0FT3UMbmEb8Gew0',
            person_id: 'frank-karreman-13b06635',
            username: 'frank-karreman-13b06635',
            headline: '--',
            name: 'Frank Karreman',
            linkedin_uid: 'AEMAAAdOHz8Bl_KrjXK4CNPh0FT3UMbmEb8Gew0',
            source: 'cvt',
            experiences: {
              jobs: [
                {
                  role: 'Profvoetballer',
                  description: '',
                  company: {
                    name: 'FC Utrecht',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2001,
                    },
                    end: {
                      month: 6,
                      year: 2003,
                    },
                    end_recalculated: 24042,
                    start_recalculated: 24019,
                  },
                },
                {
                  role: 'Profvoetaller',
                  description: '',
                  company: {
                    name: 'FC Emmen',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2003,
                    },
                    end: {
                      month: 6,
                      year: 2007,
                    },
                    end_recalculated: 24090,
                    start_recalculated: 24043,
                  },
                },
                {
                  role: 'Profvoetballer',
                  description: '',
                  company: {
                    name: 'HFC Haarlem',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2007,
                    },
                    end: {
                      month: 6,
                      year: 2010,
                    },
                    end_recalculated: 24126,
                    start_recalculated: 24091,
                  },
                },
                {
                  role: 'Productie medewerker',
                  description: '',
                  company: {
                    name: 'Dukreuk',
                  },
                  dates: {
                    start: {
                      month: 12,
                      year: 2012,
                    },
                    end: {
                      month: 12,
                      year: 2016,
                    },
                    end_recalculated: 24204,
                    start_recalculated: 24156,
                  },
                },
                {
                  role: 'Beveiligingsadviseur ',
                  description: '',
                  company: {
                    name: 'Verisure Securitas Direct',
                  },
                  dates: {
                    start: {
                      month: 6,
                      year: 2016,
                    },
                    end: {
                      month: 12,
                      year: 2016,
                    },
                    end_recalculated: 24204,
                    start_recalculated: 24198,
                  },
                },
                {
                  role: 'Magazijnmedewerker',
                  description: '\nSkills: Heftruckbesturing',
                  company: {
                    name: 'YAMATO TRANSPORT U.S.A., INC.',
                  },
                  dates: {
                    start: {
                      month: 12,
                      year: 2017,
                    },
                    end: {
                      month: 12,
                      year: 2018,
                    },
                    end_recalculated: 24228,
                    start_recalculated: 24216,
                  },
                },
                {
                  role: 'Magazijnmedewerker',
                  description: '\nSkills: Heftruckbesturing, Palletwagen, Verzenden en ontvangen, Magazijn',
                  company: {
                    name: 'Bouwcenter Logus-De Hoop',
                  },
                  dates: {
                    start: {
                      month: 12,
                      year: 2018,
                    },
                    start_recalculated: 24228,
                  },
                },
              ],
              educations: [
                {
                  field: 'filiaalbeheerder',
                  school: {
                    name: 'ROC Zadkine',
                  },
                  degree: 'MBO niveau 4',
                  dates: {
                    start: {
                      year: 2000,
                    },
                    end: {
                      year: 2003,
                    },
                    end_recalculated: 24048,
                    start_recalculated: 24001,
                  },
                },
              ],
              skills: [
                {
                  name: 'Heftruckbesturing',
                },
                {
                  name: 'Palletwagen',
                },
                {
                  name: 'Verzenden en ontvangen',
                },
                {
                  name: 'Magazijn',
                },
              ],
              courses: [],
              languages: [],
              volunteer: [],
              certifications: [],
              relocations: [],
            },
            location: {
              exists: true,
              raw: 'Ridderkerk, Zuid-Holland, Nederland',
              coordinates: {
                lat: 51.8714812,
                lon: 4.5999778,
              },
              city: {
                short_name: 'Ridderkerk',
                long_name: 'Ridderkerk',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '2981EA',
              address: 'Ridderkerk, Zuid-Holland, Nederland, 2981EA, Nederland',
              place_id: 164387,
              aggregate: [null, 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            contact_info: {
              cvt: ['https://www.linkedin.com/in/AEMAAAdOHz8Bl_KrjXK4CNPh0FT3UMbmEb8Gew0'],
            },
            industry: 'Beveiliging',
            crawlerMeta: {
              updatedAt: '2025-11-07T11:12:57.262Z',
            },
            isVisible: true,
            openToNewOpportunities: true,
            linkedinVersion: 'v.2022',
            sourceMeta: {
              updatedAt: '2025-11-07T08:00:00.000Z',
              changedAt: '2025-11-07T11:12:57.552Z',
            },
            meta: {
              experience: {
                academic: {
                  first: 24001,
                  last: 24048,
                  gap: 0,
                },
                professional: {
                  first: 24019,
                  last: null,
                  gap: 44,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Magazijnmedewerker',
            recent_job_titles: 'Magazijnmedewerker Magazijnmedewerker',
            past_job_titles: 'Profvoetballer Profvoetaller Profvoetballer Productie medewerker Beveiligingsadviseur ',
            insights: [
              {
                createdAt: '2025-11-07T11:12:57.262Z',
                newValue: {
                  name: '\nSkills: Heftruckbesturing, Palletwagen, Verzenden en ontvangen, Magazijn',
                },
                _id: '690dd439c7edac35ebee4658',
                oldValue: {
                  name: '\nSkills: Palletwagen, Verzenden en ontvangen, Magazijn',
                },
                candidateId: 'AEMAAAdOHz8Bl_KrjXK4CNPh0FT3UMbmEb8Gew0',
                type: 'jobs_description.changed',
                platform: 'linkedin_classic',
              },
              {
                createdAt: '2025-11-07T11:12:57.262Z',
                newValue: {
                  name: '\nSkills: Heftruckbesturing',
                },
                _id: '690dd439c7edac35ebee4659',
                oldValue: {
                  name: '',
                },
                candidateId: 'AEMAAAdOHz8Bl_KrjXK4CNPh0FT3UMbmEb8Gew0',
                type: 'jobs_description.changed',
                platform: 'linkedin_classic',
              },
              {
                createdAt: '2025-11-07T11:12:57.262Z',
                newValue: {
                  name: 'Magazijn',
                },
                _id: '690dd439c7edac35ebee465a',
                oldValue: null,
                candidateId: 'AEMAAAdOHz8Bl_KrjXK4CNPh0FT3UMbmEb8Gew0',
                type: 'skills.added',
                platform: 'linkedin_classic',
              },
            ],
            last_insight_date: '2025-11-07T11:12:57.262Z',
            new_candidate_date: '2025-05-26T13:35:22.980Z',
          },
          sort: [0, 1762513977262],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 16,
              duration_minutes: 51,
            },
            driving: {
              distance_km: 17,
              duration_minutes: 18,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'cvt-AEMAACfcoqoBt7mma_ENrCmRfSUdeO5JIs9rbDs',
          _score: 23.466167,
          _ignored: ['location.aggregate.completion', 'location.region.level2.long_name.completion'],
          _source: {
            id: 'AEMAACfcoqoBt7mma_ENrCmRfSUdeO5JIs9rbDs',
            person_id: 'xavihaarsma',
            username: 'xavihaarsma',
            headline: 'Specialist @ Apple',
            name: 'Xavi H.',
            linkedin_uid: 'AEMAACfcoqoBt7mma_ENrCmRfSUdeO5JIs9rbDs',
            source: 'cvt',
            experiences: {
              jobs: [
                {
                  role: 'Schoonmaker',
                  description: '',
                  company: {
                    name: 'Balans Schoonmaak- en Bedrijfsdiensten B.V.',
                  },
                  dates: {
                    start: {
                      year: 2016,
                    },
                    end: {
                      year: 2019,
                    },
                    end_recalculated: 24240,
                    start_recalculated: 24193,
                  },
                },
                {
                  role: 'Stagiair ICT',
                  description:
                    "•\tPc's bouwen op maat\n•\tAdvies geven\n•\tStoringen oplossen\n•\tVerschillende apparaten repareren\nSkills: ICT, Servicedesk, Microsoft 365, Windows 10",
                  company: {
                    name: 'PC Snelservice',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2017,
                    },
                    end: {
                      month: 7,
                      year: 2018,
                    },
                    end_recalculated: 24223,
                    start_recalculated: 24213,
                  },
                },
                {
                  role: 'Stagiair ICT',
                  description:
                    '•\tHelpdesk\n•\tStoringen verhelpen\n•\tMicrosoft Intune\n•\tApple MDM\nSkills: TopDesk, ICT, Servicedesk, Microsoft 365, Windows 10',
                  company: {
                    name: 'Stichting BOOR',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2019,
                    },
                    end: {
                      month: 1,
                      year: 2020,
                    },
                    end_recalculated: 24241,
                    start_recalculated: 24237,
                  },
                },
                {
                  role: 'Medior Sales Advisor',
                  description:
                    '•\tKlantgesprekken voeren\n•\tZoeken naar de complete oplossing\n•\tVerkoop van Apple producten\n•\tSupport leveren',
                  company: {
                    name: 'Amac | Apple Premium Reseller',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2019,
                    },
                    end: {
                      month: 8,
                      year: 2022,
                    },
                    end_recalculated: 24272,
                    start_recalculated: 24237,
                  },
                },
                {
                  role: 'Stagiair ICT',
                  description:
                    '•\tHelpdesk\n•\tStoringen verhelpen\n•\tApple School Manager\n•\tJamf School\n•\tLinux Observium omgeving opzetten\nSkills: ICT, Microsoft 365, Windows 10',
                  company: {
                    name: 'VSO de Hoge Brug Rotterdam',
                  },
                  dates: {
                    start: {
                      month: 2,
                      year: 2021,
                    },
                    end: {
                      month: 6,
                      year: 2021,
                    },
                    end_recalculated: 24258,
                    start_recalculated: 24254,
                  },
                },
                {
                  role: 'Logistiek medewerker',
                  description: '•\tVracht inboeken\n•\tSupply management\n•\tOrders picken & toewijzen',
                  company: {
                    name: 'Amac | Apple Premium Reseller',
                  },
                  dates: {
                    start: {
                      month: 3,
                      year: 2021,
                    },
                    end: {
                      month: 8,
                      year: 2022,
                    },
                    end_recalculated: 24272,
                    start_recalculated: 24255,
                  },
                },
                {
                  role: 'Servicemedewerker',
                  description: '- iOS & macOS Support',
                  company: {
                    name: 'Amac | Apple Premium Reseller',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2021,
                    },
                    end: {
                      month: 8,
                      year: 2022,
                    },
                    end_recalculated: 24272,
                    start_recalculated: 24261,
                  },
                },
                {
                  role: 'Specialist',
                  description:
                    '•Begeleid klanten in het kiezen en ervaren van Apple-producten en accessoires. \n\n•Helpen van klanten met directe vragen en het geven een complete oplossingen\n\n•Zorgen voor een efficiënte en complete winkelervaring\n\t\n•Draagt bij aan een klantgerichte en servicegerichte winkelomgeving\n\nSkills: Oplossinggericht, Sociale vaardigheden, Sales',
                  company: {
                    name: 'Apple',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2022,
                    },
                    start_recalculated: 24273,
                  },
                },
                {
                  role: 'Specialist',
                  description: '',
                  company: {
                    name: 'Apple',
                  },
                  dates: {
                    start: {
                      month: 6,
                      year: 2025,
                    },
                    end: {
                      month: 8,
                      year: 2025,
                    },
                    end_recalculated: 24308,
                    start_recalculated: 24306,
                  },
                },
              ],
              educations: [
                {
                  field: 'Voortgezet middelbaar onderwijs (VMBO)',
                  school: {
                    name: 'Lentiz | LIFE College',
                  },
                  degree: 'Media & Design',
                  description: 'Afgerond met diploma. ',
                  dates: {
                    start: {
                      year: 2012,
                    },
                    end: {
                      year: 2016,
                    },
                    end_recalculated: 24204,
                    start_recalculated: 24145,
                  },
                },
                {
                  field: 'Middelbaar beroepsonderwijs (MBO 2)',
                  school: {
                    name: 'Techniek College Rotterdam',
                  },
                  degree: 'Medewerker ICT',
                  description: 'Binnen 6 maanden doorgestroomd naar een versneld MBO niveau 3 traject.',
                  dates: {
                    start: {
                      year: 2016,
                    },
                    end: {
                      year: 2016,
                    },
                    end_recalculated: 24204,
                    start_recalculated: 24193,
                  },
                },
                {
                  field: 'Middelbaar beroepsonderwijs (MBO 3)',
                  school: {
                    name: 'Techniek College Rotterdam',
                  },
                  degree: 'Medewerker beheer ICT ',
                  description: 'Afgerond met diploma. ',
                  dates: {
                    start: {
                      year: 2016,
                    },
                    end: {
                      year: 2018,
                    },
                    end_recalculated: 24228,
                    start_recalculated: 24193,
                  },
                },
                {
                  field: 'Middelbaar beroepsonderwijs (MBO 4)',
                  school: {
                    name: 'Techniek College Rotterdam',
                  },
                  degree: 'Netwerkbeheer',
                  description: 'Afgerond met diploma.',
                  dates: {
                    start: {
                      year: 2018,
                    },
                    end: {
                      year: 2021,
                    },
                    end_recalculated: 24264,
                    start_recalculated: 24217,
                  },
                },
              ],
              skills: [
                {
                  name: 'TopDesk',
                },
                {
                  name: 'ICT',
                },
                {
                  name: 'Servicedesk',
                },
                {
                  name: 'Microsoft 365',
                },
                {
                  name: 'Windows 10',
                },
                {
                  name: 'Oplossinggericht',
                },
                {
                  name: 'Sociale vaardigheden',
                },
                {
                  name: 'Computerreparaties',
                },
                {
                  name: 'Computeronderhoud',
                },
                {
                  name: 'Computers bouwen',
                },
                {
                  name: 'Klantenservice',
                },
                {
                  name: 'Probleemoplossing',
                },
                {
                  name: 'Linux',
                },
                {
                  name: 'Windows',
                },
                {
                  name: 'Macos',
                },
                {
                  name: 'Computernetwerken',
                },
                {
                  name: 'Groepswerk',
                },
                {
                  name: 'Sales',
                },
                {
                  name: 'Mobiel apparaatbeheer',
                },
                {
                  name: 'Microsoft Office 365',
                },
              ],
              courses: [],
              languages: [],
              volunteer: [],
              certifications: [
                {
                  name: 'Security 1',
                  dates: {
                    start: {
                      month: 7,
                      year: 2019,
                    },
                  },
                },
                {
                  name: 'Technical Support Fundamentals',
                  dates: {
                    start: {
                      month: 3,
                      year: 2023,
                    },
                  },
                },
                {
                  name: 'Aries PC Technician',
                  dates: {
                    start: {
                      month: 6,
                      year: 2019,
                    },
                  },
                },
              ],
              relocations: [],
            },
            location: {
              exists: true,
              raw: 'Rotterdam, Zuid-Holland, Nederland',
              coordinates: {
                lat: 51.9244424,
                lon: 4.47775,
              },
              city: {
                short_name: 'Rotterdam',
                long_name: 'Rotterdam',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '',
              address: 'Rotterdam, Zuid-Holland, Nederland',
              place_id: 13301987,
              aggregate: ['Rotterdam', 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            contact_info: {
              cvt: ['https://www.linkedin.com/in/AEMAACfcoqoBt7mma_ENrCmRfSUdeO5JIs9rbDs'],
            },
            industry: 'Productie computers en elektronische apparaten',
            crawlerMeta: {
              updatedAt: '2025-11-07T10:44:27.181Z',
            },
            isVisible: true,
            openToNewOpportunities: true,
            linkedinVersion: 'v.2022',
            sourceMeta: {
              updatedAt: '2025-11-07T08:00:00.000Z',
              changedAt: '2025-11-07T10:44:27.382Z',
            },
            meta: {
              experience: {
                academic: {
                  first: 24145,
                  last: 24264,
                  gap: 0,
                },
                professional: {
                  first: 24193,
                  last: null,
                  gap: 1,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Specialist',
            recent_job_titles: 'Specialist Specialist',
            past_job_titles:
              'Schoonmaker Stagiair ICT Stagiair ICT Medior Sales Advisor Stagiair ICT Logistiek medewerker Servicemedewerker',
            insights: [
              {
                createdAt: '2025-11-07T10:44:27.181Z',
                newValue: {
                  name: 'Servicemedewerker',
                },
                _id: '690dcd8b2edec109f849fe34',
                oldValue: {
                  name: 'Service Employee',
                },
                candidateId: 'AEMAACfcoqoBt7mma_ENrCmRfSUdeO5JIs9rbDs',
                type: 'jobs_role.changed',
                platform: 'linkedin_classic',
              },
              {
                createdAt: '2025-11-07T10:44:27.181Z',
                newValue: {
                  name: 'Logistiek medewerker',
                },
                _id: '690dcd8b2edec109f849fe35',
                oldValue: {
                  name: 'Side task: Logistics',
                },
                candidateId: 'AEMAACfcoqoBt7mma_ENrCmRfSUdeO5JIs9rbDs',
                type: 'jobs_role.changed',
                platform: 'linkedin_classic',
              },
              {
                createdAt: '2025-11-07T10:44:27.181Z',
                newValue: {
                  name: 'Stagiair ICT',
                },
                _id: '690dcd8b2edec109f849fe36',
                oldValue: {
                  name: 'IT Internship',
                },
                candidateId: 'AEMAACfcoqoBt7mma_ENrCmRfSUdeO5JIs9rbDs',
                type: 'jobs_role.changed',
                platform: 'linkedin_classic',
              },
            ],
            last_insight_date: '2025-11-07T10:44:27.181Z',
            new_candidate_date: '2025-03-06T10:46:19.175Z',
          },
          sort: [0, 1762512267181],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 10,
              duration_minutes: 32,
            },
            driving: {
              distance_km: 11,
              duration_minutes: 18,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'nvb-9f20a918-bc0c-11e6-a8e5-18ab7bf9d9ec',
          _score: 18.4391,
          _ignored: ['location.aggregate.completion', 'location.region.level2.long_name.completion'],
          _source: {
            id: '9f20a918-bc0c-11e6-a8e5-18ab7bf9d9ec',
            experiences: {
              jobs: [
                {
                  role: 'heftruck chauffeur',
                  description:
                    'Ik ben full around werkzaam bij Estron group, doe dit werk al jaren, maar langzaamaan wordt het tijd voor andere werkgever. Ik kan zo beginnen bij een nieuwe werkgever, ik heb geen opzeg termijn. En ben 52 jaar.',
                  dates: {
                    start: {
                      month: 1,
                      year: 2006,
                    },
                    end: {
                      month: 1,
                      year: 2021,
                    },
                    end_recalculated: 24253,
                    start_recalculated: 24073,
                  },
                  company: {
                    name: 'estron group',
                  },
                  id: 'd733b1cd-47ea-493b-b0d5-f6b59919f8df',
                },
                {
                  role: 'Loodsmedewerker',
                  description:
                    'Orders en klaarmaken en verzamelen via een reachtruck of hefttruck. Verwerken in het Sap systeem voor klanten zoals Shell en Lyondell enz.....',
                  dates: {
                    start: {
                      month: 1,
                      year: 2021,
                    },
                    start_recalculated: 24253,
                  },
                  company: {
                    name: 'Eriks',
                  },
                  id: '0b398106-489d-466a-92ba-47367a03a63f',
                },
              ],
              educations: [
                {
                  field: 'voedingswaren',
                  school: {
                    name: 'ADM',
                  },
                  degree: 'LBO',
                  description:
                    '<p>bij dit bedrijf met plezier gewerkt helaas was ik onder een onderaannemer daar te werk gesteld. Super bazen goede mentaliteit, maar Adm ging de fabriek draaien op eigen mensen dus toen moest ik weg vond en vind het nog steeds jammer.</p>',
                  dates: {
                    start: {
                      month: 1,
                      year: 2000,
                    },
                    end: {
                      month: 1,
                      year: 2002,
                    },
                    end_recalculated: 24025,
                    start_recalculated: 24001,
                  },
                  id: 'a32e809a-9b2e-11e8-be9c-0242ac110005',
                  obtainedDegree: true,
                },
              ],
              languages: [
                {
                  proficiencyWritten: 'excellent',
                  name: 'Dutch',
                  proficiency: 'excellent',
                },
              ],
              skills: [],
              certifications: [
                {
                  name: 'Ploegleider Bhv',
                  description: "<p>Leiden van een ploeg Bhv's bij calamiteiten</p>",
                  company: {
                    name: 'Delta safety training',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2024,
                    },
                    end: {
                      month: 1,
                      year: 2024,
                    },
                  },
                  id: '868539bc-d9d7-4921-b83a-09942f577036',
                },
                {
                  name: 'Bhv',
                  description: '',
                  company: {
                    name: 'Delta safety training',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2023,
                    },
                    end: {
                      month: 1,
                      year: 2023,
                    },
                  },
                  id: '4bc96ac0-cc60-4d04-a3d3-5a3c2fd682a0',
                },
                {
                  name: 'Reachtruck',
                  description: '<p>Is weer verlengt en weer helemaal geldig en 17 jaar ervaring ermee.</p>',
                  company: {
                    name: 'Westpoort',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2022,
                    },
                    end: {
                      month: 1,
                      year: 2022,
                    },
                  },
                  id: 'a7340df6-e76e-4a32-9336-62de5b179594',
                },
                {
                  name: 'heftruck chauffeur',
                  description: '<p>weer voor 5 jaar verlegd al meer dan 17 jaar ervaring</p>',
                  company: {
                    name: 'blom',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2021,
                    },
                    end: {
                      month: 9,
                      year: 2021,
                    },
                  },
                  id: '92b5ba64-6fe7-4a60-bf7f-40ac5cab1191',
                },
                {
                  name: 'veiligheidspas',
                  description: '',
                  company: {
                    name: 'ito',
                  },
                  dates: {
                    start: {
                      month: 10,
                      year: 2013,
                    },
                    end: {
                      month: 10,
                      year: 2013,
                    },
                  },
                  id: '4e0f9284-9b2e-11e8-ae97-0242ac110005',
                },
              ],
            },
            licenses: [
              {
                name: 'B',
                type: 'driving_license_code',
              },
            ],
            interests: [],
            description:
              'Ik ben een harde werker en heb oog voor verbeteringen en veiligheid. Soms een keertje overwerken, maar niet vaak want ik wil ook kunnen genieten van mijn prive tijd. Ik doe dit werk al heel wat jaren, dus breng ook een hoop werkervaring mee. Ik verdien bij mijn huidige baas bijna 3000 bruto p.m. en krijg ook een winstuitkering van zeker 1 maand loon netto. Bij jullie geen winstuitkering, dan wil ik tegen de 3500 bruto p.m. en gelijk een contract onbepaalde tijd.',
            name: 'john mullenders',
            industries: ['Overig', 'Inkoop/Logistiek/Transport'],
            source: 'nvb',
            photos: [
              'https://d35ajla5icumre.cloudfront.net/profile-photos/9f20a918-bc0c-11e6-a8e5-18ab7bf9d9ec/ebf9b7b8-ecf6-48c6-a87f-5a748b57f816.jpg',
            ],
            contact_info: {
              email: ['johnmull@ziggo.nl'],
              phone: ['0618472417'],
              nvb: [
                'https://www.persgroepemploymentsolutions.nl/recruiter/kandidaat/9f20a918-bc0c-11e6-a8e5-18ab7bf9d9ec',
              ],
            },
            location: {
              exists: true,
              raw: ' 3181XA Rozenburg Zuid-Holland NL',
              coordinates: {
                lat: 51.904439853125,
                lon: 4.25170233125,
              },
              city: {
                short_name: 'Rozenburg',
                long_name: 'Rozenburg',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '3181XA',
              address: 'Rozenburg, Rotterdam, Zuid-Holland, Nederland, 3181XA, Nederland',
              place_id: 11622867,
              aggregate: ['Rozenburg', 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            preferences: {
              workHours: {
                min: 32,
                max: 40,
              },
              jobTitles: ['loodsmedewerker', 'heftruck-reach-combi chauffeur', 'orderpicker'],
              salaryRange: {
                min: 2500,
                max: 3500,
                currency: 'EUR',
                recurrence: 'monthly',
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 30,
              },
            },
            migration: {},
            sourceMeta: {
              updatedAt: '2025-11-07T09:00:04.000Z',
              changedAt: '2025-11-07T09:00:13.945Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-07T09:57:35.723Z',
            },
            isVisible: true,
            cvFileId: 'cv-f630380e2ce477485485921c5887d3319eb483756c49a10cfce6ead0ec091a19.pdf',
            meta: {
              experience: {
                academic: {
                  first: 24001,
                  last: 24025,
                  gap: 0,
                },
                professional: {
                  first: 24073,
                  last: null,
                  gap: 0,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'Loodsmedewerker',
            recent_job_titles: 'Loodsmedewerker heftruck chauffeur',
            past_job_titles: '',
            headline: 'Loodsmedewerker',
            insights: [
              {
                createdAt: '2025-11-07T09:00:03.258Z',
                newValue: {
                  month: 1,
                  year: 2021,
                },
                _id: '690db513c1845fb2816c2c99',
                oldValue: {
                  month: 12,
                  year: 2021,
                },
                candidateId: '9f20a918-bc0c-11e6-a8e5-18ab7bf9d9ec',
                type: 'jobs_dates_start.changed',
                platform: 'nvb',
              },
              {
                createdAt: '2025-11-07T08:59:43.174Z',
                newValue: {
                  role: 'heftruck chauffeur',
                  description:
                    'Ik ben full around werkzaam bij Estron group, doe dit werk al jaren, maar langzaamaan wordt het tijd voor andere werkgever. Ik kan zo beginnen bij een nieuwe werkgever, ik heb geen opzeg termijn. En ben 52 jaar.',
                  dates: {
                    start: {
                      month: 1,
                      year: 2006,
                    },
                    end: {
                      month: 1,
                      year: 2021,
                    },
                  },
                  company: {
                    name: 'estron group',
                  },
                  id: 'd733b1cd-47ea-493b-b0d5-f6b59919f8df',
                },
                _id: '690db4ffdd9ae9a119938d76',
                oldValue: null,
                candidateId: '9f20a918-bc0c-11e6-a8e5-18ab7bf9d9ec',
                type: 'jobs.added',
                platform: 'nvb',
              },
              {
                createdAt: '2023-05-01T10:04:03.877Z',
                newValue: {
                  min: 32,
                  max: 40,
                },
                _id: '644f8e93abd8c32733ada560',
                oldValue: {
                  min: 40,
                  max: 40,
                },
                candidateId: '9f20a918-bc0c-11e6-a8e5-18ab7bf9d9ec',
                type: 'preferences_workHours.changed',
                platform: 'nvb',
              },
            ],
            last_insight_date: '2025-11-07T09:00:04.000Z',
            new_candidate_date: null,
          },
          sort: [0, 1762506004000],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 20,
              duration_minutes: 64,
            },
            driving: {
              distance_km: 19,
              duration_minutes: 20,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'cvt-ACoAADN2PmoBrJ0FOyUWwb1FWZBG4sz50x4qlTs',
          _score: 16.78955,
          _ignored: ['location.aggregate.completion', 'location.region.level2.long_name.completion'],
          _source: {
            id: 'ACoAADN2PmoBrJ0FOyUWwb1FWZBG4sz50x4qlTs',
            person_id: 'surajh-nakched-48a191201',
            username: 'surajh-nakched-48a191201',
            headline: 'Chauffeur bij EBS Public Transportation BV',
            name: 'Surajh Nakched',
            linkedin_uid: 'ACoAADN2PmoBrJ0FOyUWwb1FWZBG4sz50x4qlTs',
            source: 'cvt',
            experiences: {
              jobs: [
                {
                  role: 'Machineoperator',
                  description: '',
                  company: {
                    name: 'Mediq',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2013,
                    },
                    end: {
                      month: 8,
                      year: 2015,
                    },
                    end_recalculated: 24188,
                    start_recalculated: 24163,
                  },
                },
                {
                  role: 'Orderpicker',
                  description: '',
                  company: {
                    name: 'Rexel Nederland',
                  },
                  dates: {
                    start: {
                      month: 8,
                      year: 2015,
                    },
                    end: {
                      month: 7,
                      year: 2016,
                    },
                    end_recalculated: 24199,
                    start_recalculated: 24188,
                  },
                },
                {
                  role: 'Magazijnmedewerker',
                  description: '',
                  company: {
                    name: 'Fagron Nederland',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2016,
                    },
                    end: {
                      month: 3,
                      year: 2017,
                    },
                    end_recalculated: 24207,
                    start_recalculated: 24199,
                  },
                },
                {
                  role: 'Bestuurder openbaar vervoer',
                  description: '',
                  company: {
                    name: 'Connexxion',
                  },
                  dates: {
                    start: {
                      month: 3,
                      year: 2017,
                    },
                    end: {
                      month: 12,
                      year: 2018,
                    },
                    end_recalculated: 24228,
                    start_recalculated: 24207,
                  },
                },
                {
                  role: 'Chauffeur',
                  description: '',
                  company: {
                    name: 'EBS Public Transportation BV',
                  },
                  dates: {
                    start: {
                      month: 12,
                      year: 2018,
                    },
                    start_recalculated: 24228,
                  },
                },
              ],
              educations: [
                {
                  field: 'Elektro- technische leerweg',
                  school: {
                    name: 'nieuw rotterdam',
                  },
                  degree: 'vmbo',
                  dates: {
                    start: {
                      year: 2001,
                    },
                    end: {
                      year: 2005,
                    },
                    end_recalculated: 24072,
                    start_recalculated: 24013,
                  },
                },
                {
                  field: 'servicemedewerker ict',
                  school: {
                    name: 'Albeda mbo alumni',
                  },
                  degree: 'mbo',
                  dates: {
                    start: {
                      year: 2005,
                    },
                    end: {
                      year: 2007,
                    },
                    end_recalculated: 24096,
                    start_recalculated: 24061,
                  },
                },
              ],
              skills: [
                {
                  name: 'Microsoft Office',
                },
                {
                  name: 'Microsoft windows',
                },
              ],
              courses: [],
              languages: [
                {
                  name: 'Nederlands',
                  proficiency: 'native or bilingual',
                },
                {
                  name: 'Engels',
                  proficiency: 'elementary',
                },
              ],
              volunteer: [],
              certifications: [],
              relocations: [],
            },
            location: {
              exists: true,
              raw: 'Rotterdam, South Holland, Netherlands',
              coordinates: {
                lat: 51.9244424,
                lon: 4.47775,
              },
              city: {
                short_name: 'Rotterdam',
                long_name: 'Rotterdam',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '',
              address: 'Rotterdam, Zuid-Holland, Nederland',
              place_id: 13301987,
              aggregate: ['Rotterdam', 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            contact_info: {
              cvt: ['https://www.linkedin.com/in/ACoAADN2PmoBrJ0FOyUWwb1FWZBG4sz50x4qlTs'],
            },
            industry: 'Truck Transportation',
            crawlerMeta: {
              updatedAt: '2025-11-07T10:58:00.357Z',
            },
            isVisible: true,
            openToNewOpportunities: true,
            linkedinVersion: 'v.2022',
            sourceMeta: {
              updatedAt: '2025-11-07T08:00:00.000Z',
              changedAt: '2025-11-07T10:58:00.357Z',
            },
            meta: {
              experience: {
                academic: {
                  first: 24013,
                  last: 24096,
                  gap: 0,
                },
                professional: {
                  first: 24163,
                  last: null,
                  gap: 0,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Chauffeur',
            recent_job_titles: 'Chauffeur Bestuurder openbaar vervoer',
            past_job_titles: 'Machineoperator Orderpicker Magazijnmedewerker',
            insights: [],
            last_insight_date: '2025-11-07T08:00:00.000Z',
            new_candidate_date: null,
          },
          sort: [0, 1762502400000],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 10,
              duration_minutes: 32,
            },
            driving: {
              distance_km: 11,
              duration_minutes: 18,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-7553225',
          _score: 12.267423,
          _ignored: [
            'location.city.long_name.completion',
            'location.aggregate.completion',
            'location.region.level2.long_name.completion',
          ],
          _source: {
            id: 7553225,
            source: 'werknl',
            headline: 'Productiemedewerker',
            description: null,
            experiences: {
              jobs: [
                {
                  role: 'Productiemedewerker',
                  description: null,
                  employment_hours: 35,
                  dates: {
                    start: {
                      month: 4,
                      year: 2011,
                    },
                    end: {
                      month: 4,
                      year: 2013,
                    },
                    start_recalculated: 24136,
                    end_recalculated: 24160,
                  },
                },
                {
                  role: 'Productiemedewerker',
                  description: null,
                  employment_hours: 40,
                  dates: {
                    start: {
                      month: 9,
                      year: 2017,
                    },
                    end: {
                      month: 12,
                      year: 2021,
                    },
                    start_recalculated: 24213,
                    end_recalculated: 24264,
                  },
                },
                {
                  role: 'Postsorteerder',
                  description: null,
                  employment_hours: 38,
                  dates: {
                    start: {
                      month: 4,
                      year: 2023,
                    },
                    end: {
                      month: 10,
                      year: 2025,
                    },
                    start_recalculated: 24280,
                    end_recalculated: 24310,
                  },
                },
              ],
              educations: [
                {
                  degree: 'verkoper (mbo-2)',
                  dates: {
                    start: {
                      month: 9,
                      year: 2000,
                    },
                    end: {
                      month: 4,
                      year: 2003,
                    },
                    start_recalculated: 24009,
                    end_recalculated: 24040,
                  },
                  obtainedDegree: true,
                },
              ],
              skills: [],
              certifications: [],
              languages: [
                {
                  name: 'Engels',
                  proficiency: 'limited',
                  proficiencyWritten: 'unknown',
                },
                {
                  name: 'Pools',
                  proficiency: 'fluent',
                  proficiencyWritten: 'fluent',
                },
              ],
            },
            licenses: [
              {
                type: 'driving_license_code',
                name: 'B',
              },
            ],
            interests: [],
            contact_info: {
              email: [],
              phone: [],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/7553225'],
            },
            location: {
              exists: true,
              raw: '3314WH',
              coordinates: {
                lat: 51.80290714399999,
                lon: 4.653218408,
              },
              city: {
                short_name: '',
                long_name: '',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '3314WH',
              address: '3314WH',
              place_id: 11631553,
              aggregate: [null, 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            sourceMeta: {
              updatedAt: '2025-11-06T17:10:34.043Z',
              changedAt: '2025-11-07T07:11:58.319Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-07T07:11:58.307Z',
            },
            preferences: {
              jobTitles: [
                'Productiemedewerker, Productiemedewerker',
                'Postsorteerder, Postsorteerder',
                'Magazijnmedewerker, Magazijnmedewerker',
              ],
              workHours: {
                min: 40,
                max: 40,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 50,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 24009,
                  last: 24040,
                  gap: 0,
                },
                professional: {
                  first: 24136,
                  last: 24310,
                  gap: 69,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'Postsorteerder',
            recent_job_titles: 'Postsorteerder Productiemedewerker',
            past_job_titles: 'Productiemedewerker',
            insights: [
              {
                _id: '690d9bbe27199a41bf213d96',
                createdAt: '2025-11-07T07:11:58.312Z',
                platform: 'werknl',
                candidateId: 7553225,
                type: 'candidate.added',
                newValue: null,
                oldValue: null,
              },
            ],
            last_insight_date: '2025-11-07T07:11:58.312Z',
            new_candidate_date: '2025-11-07T07:11:58.312Z',
          },
          sort: [0, 1762499518312],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 23,
              duration_minutes: 75,
            },
            driving: {
              distance_km: 24,
              duration_minutes: 24,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-7541563',
          _score: 12.941446,
          _ignored: ['location.aggregate.completion', 'location.region.level2.long_name.completion'],
          _source: {
            id: 7541563,
            source: 'werknl',
            name: 'Grzegorz Artur Bielecki',
            headline: 'technisch binnendienst medewerker',
            description: null,
            experiences: {
              jobs: [
                {
                  role: 'Orderpicker',
                  employment_hours: 45,
                  description: 'Orderpicker',
                  company: {
                    name: 'Natures Pride',
                  },
                  dates: {
                    start: {
                      month: 11,
                      year: 2013,
                    },
                    end: {
                      month: 12,
                      year: 2016,
                    },
                    end_recalculated: 24204,
                    start_recalculated: 24167,
                  },
                },
                {
                  role: 'Productiemedewerker',
                  employment_hours: 50,
                  description: null,
                  company: {
                    name: 'P.Looje verpakking ',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2017,
                    },
                    end: {
                      month: 12,
                      year: 2017,
                    },
                    end_recalculated: 24216,
                    start_recalculated: 24205,
                  },
                },
                {
                  role: 'Heftruckchauffeur',
                  employment_hours: 45,
                  description: 'Heftruckchauffeur ',
                  company: {
                    name: 'Gebr. Nederpel',
                  },
                  dates: {
                    start: {
                      month: 2,
                      year: 2018,
                    },
                    end: {
                      month: 7,
                      year: 2020,
                    },
                    end_recalculated: 24247,
                    start_recalculated: 24218,
                  },
                },
                {
                  role: 'service medewerker',
                  employment_hours: 50,
                  description: 'Service medewerker ',
                  company: {
                    name: 'Holland Licht ',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2020,
                    },
                    end: {
                      month: 1,
                      year: 2021,
                    },
                    end_recalculated: 24253,
                    start_recalculated: 24247,
                  },
                },
                {
                  role: 'service medewerker',
                  employment_hours: 45,
                  description: 'Service medewerker ',
                  company: {
                    name: 'Total Service Tuinbouw',
                  },
                  dates: {
                    start: {
                      month: 2,
                      year: 2021,
                    },
                    end: {
                      month: 9,
                      year: 2024,
                    },
                    end_recalculated: 24297,
                    start_recalculated: 24254,
                  },
                },
                {
                  role: 'service medewerker',
                  employment_hours: 45,
                  description: 'Scherm service ',
                  company: {
                    name: 'Schermned ',
                  },
                  dates: {
                    start: {
                      month: 10,
                      year: 2024,
                    },
                    end: {
                      month: 12,
                      year: 2024,
                    },
                    end_recalculated: 24300,
                    start_recalculated: 24298,
                  },
                },
                {
                  role: 'technisch binnendienst medewerker',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'Growers United',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2025,
                    },
                    end: {
                      month: 8,
                      year: 2025,
                    },
                    end_recalculated: 24308,
                    start_recalculated: 24301,
                  },
                },
              ],
              educations: [
                {
                  degree: 'heftruckchauffeur cvv (mbo)',
                  dates: {
                    start: {
                      month: 4,
                      year: 2010,
                    },
                    start_recalculated: 24124,
                  },
                  obtainedDegree: false,
                },
              ],
              skills: [
                {
                  europass: null,
                  name: 'Logisch nadenken',
                  description: null,
                },
              ],
              certifications: [],
              languages: [
                {
                  proficiencyWritten: 'fluent',
                  name: 'Nederlands',
                  proficiency: 'fluent',
                },
              ],
            },
            licenses: [
              {
                name: 'B',
                type: 'driving_license_code',
              },
            ],
            interests: [
              {
                name: 'Vissen ',
                description: null,
              },
            ],
            contact_info: {
              email: ['bielecki275@gmail.nl'],
              phone: [],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/7541563'],
            },
            location: {
              exists: true,
              raw: 'Naaldwijk',
              coordinates: {
                lat: 51.99274816666665,
                lon: 4.201614379166666,
              },
              city: {
                short_name: 'Naaldwijk',
                long_name: 'Naaldwijk',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '2671ZH',
              address: 'Naaldwijk',
              place_id: 11589291,
              aggregate: ['Naaldwijk', 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            sourceMeta: {
              updatedAt: '2025-11-06T18:14:36.787Z',
              changedAt: '2025-11-07T07:09:31.615Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-07T07:09:31.593Z',
            },
            preferences: {
              jobTitles: [
                'medewerker technische helpdesk, Chauffeur ',
                'Heftruckchauffeur, Heftruckchauffeur ',
                'Orderpicker, Orderpicker ',
              ],
              workHours: {
                min: 40,
                max: 45,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 10,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 24124,
                  last: null,
                  gap: 0,
                },
                professional: {
                  first: 24167,
                  last: 24308,
                  gap: 6,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'technisch binnendienst medewerker',
            recent_job_titles: 'technisch binnendienst medewerker service medewerker',
            past_job_titles: 'Orderpicker Productiemedewerker Heftruckchauffeur service medewerker service medewerker',
            insights: [
              {
                createdAt: '2025-11-07T07:09:31.605Z',
                newValue: {
                  role: 'Orderpicker',
                  employment_hours: 45,
                  description: 'Orderpicker',
                  company: {
                    name: 'Natures Pride',
                  },
                  dates: {
                    start: {
                      month: 11,
                      year: 2013,
                    },
                    end: {
                      month: 12,
                      year: 2016,
                    },
                  },
                },
                _id: '690d9b2b337af190e2c72eae',
                oldValue: null,
                candidateId: 7541563,
                type: 'jobs.added',
                platform: 'werknl',
              },
              {
                createdAt: '2025-11-07T07:09:31.605Z',
                newValue: {
                  europass: null,
                  name: 'Logisch nadenken',
                  description: null,
                },
                _id: '690d9b2b337af190e2c72eaf',
                oldValue: null,
                candidateId: 7541563,
                type: 'skills.added',
                platform: 'werknl',
              },
              {
                createdAt: '2025-10-20T11:18:17.839Z',
                newValue: null,
                _id: '68f61a79de8a18798b4c1c75',
                oldValue: null,
                candidateId: 7541563,
                type: 'candidate.added',
                platform: 'werknl',
              },
            ],
            last_insight_date: '2025-11-07T07:09:31.605Z',
            new_candidate_date: '2025-10-20T11:18:17.839Z',
          },
          sort: [0, 1762499371605],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 29,
              duration_minutes: 92,
            },
            driving: {
              distance_km: 29,
              duration_minutes: 27,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-7023203',
          _score: 12.898609,
          _ignored: [
            'location.city.long_name.completion',
            'location.aggregate.completion',
            'location.region.level2.long_name.completion',
          ],
          _source: {
            id: 7023203,
            source: 'werknl',
            headline: 'Financieel administratief medewerker',
            description:
              'Ik ben sociaal, leergierig, flexibel, inzetbaa,, veratnwoordelijk, klantgericht persoon.\nEen teamplayer die ook zelfstandig  goed kan functioneren.',
            experiences: {
              jobs: [
                {
                  role: 'Financieel administratief medewerker',
                  employment_hours: 39,
                  description: 'Het boeken van facturen.\nFactureren van import/export',
                  dates: {
                    start: {
                      month: 11,
                      year: 2021,
                    },
                    start_recalculated: 24263,
                  },
                },
              ],
              educations: [
                {
                  degree: 'bedrijfsadministratie (mbo sector economie)',
                  dates: {
                    start: {
                      month: 8,
                      year: 1997,
                    },
                    end: {
                      month: 6,
                      year: 2000,
                    },
                    end_recalculated: 24006,
                    start_recalculated: 23972,
                  },
                  obtainedDegree: true,
                },
              ],
              skills: [],
              certifications: [],
              languages: [
                {
                  proficiencyWritten: 'fluent',
                  name: 'Nederlands',
                  proficiency: 'fluent',
                },
              ],
              licenses: [],
            },
            interests: [],
            contact_info: {
              email: [],
              phone: [],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/7023203'],
            },
            location: {
              country: {
                short_name: 'NL',
                long_name: 'Netherlands',
              },
              aggregate: [null, 'Zuid-Holland', '', 'Nederland', 'NL'],
              raw: '3122GJ',
              address: '3122GJ',
              city: {
                short_name: '',
                long_name: '',
              },
              coordinates: {
                lon: 4.373760377777778,
                lat: 51.930941499999996,
              },
              exists: true,
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '3122GJ',
              place_id: 11619004,
            },
            sourceMeta: {
              updatedAt: '2025-11-05T22:44:37.433Z',
              changedAt: '2025-11-06T13:44:21.866Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-06T13:44:21.847Z',
            },
            preferences: {
              jobTitles: ['null, dataentry, orderpicker, magazijnmederwerker schoonmaakster'],
              workHours: {
                min: 15,
                max: 15,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 25,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 23972,
                  last: 24006,
                  gap: 0,
                },
                professional: {
                  first: 24263,
                  last: null,
                  gap: 0,
                },
                keywords: [],
                volunteer: {},
              },
            },
            current_job_title: 'Financieel administratief medewerker',
            recent_job_titles: 'Financieel administratief medewerker ',
            past_job_titles: '',
            insights: [
              {
                createdAt: '2025-11-06T13:44:21.856Z',
                newValue: {
                  name: 'Financieel administratief medewerker',
                },
                _id: '690ca635d7c8f2863cde1be6',
                oldValue: {
                  name: 'Financieel-administratief medewerker',
                },
                candidateId: 7023203,
                type: 'jobs_role.changed',
                platform: 'werknl',
              },
              {
                createdAt: '2023-04-28T10:59:51.680Z',
                newValue: null,
                _id: '644ba727b4e3055c3e8e4e13',
                oldValue: null,
                candidateId: 7023203,
                type: 'candidate.added',
                platform: 'werknl',
              },
            ],
            last_insight_date: '2025-11-06T13:44:21.856Z',
            new_candidate_date: '2023-04-28T10:59:51.680Z',
            licenses: [],
          },
          sort: [0, 1762436661856],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 12,
              duration_minutes: 40,
            },
            driving: {
              distance_km: 14,
              duration_minutes: 15,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-7048711',
          _score: 12.190197,
          _ignored: [
            'location.city.long_name.completion',
            'location.aggregate.completion',
            'location.region.level1.long_name.completion',
            'location.region.level2.long_name.completion',
          ],
          _source: {
            id: 7048711,
            source: 'werknl',
            name: 'Mohammed Sheikrafi Sheikkariem',
            headline: 'machineoperator voedingsmiddelenindustrie (mechanisch operator)',
            description:
              'Hallo, mijn naam is Mohammed en ik ben 24 jaar. Graag zou ik zo snel mogelijk aan het werk willen, daarom ontvangt u mijn CV.\n \nIk ben een zeer gemotiveerde jongeman die altijd opzoek is naar een uitdaging.\nSociaal, gedreven en betrouwbaar, zijn een paar van mijn kwaliteiten. Verder ben ik positief ingesteld, probeer ik altijd te denken in oplossingen en kritiek om te buigen naar positieve feedback. Als harde werker en teamspeler met een grote dosis doorzettingsvermogen, denk ik een goede aanvulling te zijn in uw team.\n \nHartelijk dank voor uw tijd en hopelijk tot snel.',
            experiences: {
              jobs: [
                {
                  role: 'logistiek medewerker magazijn',
                  employment_hours: 24,
                  description:
                    '- Overzien logistieke processen.\n- Laden en lossen van vrachtwagens.\n- Verzamelen en verpakken van bestellingen.\n- Ontvangen en controleren van goederen.\n- Bijhouden van de voorraad en rapporteren naar de team leader.',
                  company: {
                    name: 'Alfen',
                  },
                  dates: {
                    start: {
                      month: 6,
                      year: 2019,
                    },
                    end: {
                      month: 9,
                      year: 2020,
                    },
                    end_recalculated: 24249,
                    start_recalculated: 24234,
                  },
                },
                {
                  role: 'procesoperator voedingsmiddelenindustrie (fieldoperator)',
                  employment_hours: 33,
                  description:
                    '- Bedienen en controleren van machines en apparatuur in de productie.\n- Zorg dragen voor een goed lopend productieproces.\n- Kwaliteitscontroles van het eindproduct uitvoeren.\n- Eerste lijn storingen en kleine technische problemen zelfstandig oplossen.',
                  company: {
                    name: 'McCain Foods',
                  },
                  dates: {
                    start: {
                      month: 10,
                      year: 2020,
                    },
                    end: {
                      month: 2,
                      year: 2023,
                    },
                    end_recalculated: 24278,
                    start_recalculated: 24250,
                  },
                },
                {
                  role: 'mobiel beveiliger',
                  employment_hours: 40,
                  description:
                    '- Toezicht houden van bak/vrachtwagens met waardevolle spullen.\n- Controles uitvoeren op de wagens en ladingen.\n- Controleren of de seals juist geplaatst en verwijderd worden.',
                  company: {
                    name: 'DEVYA International',
                  },
                  dates: {
                    start: {
                      month: 2,
                      year: 2023,
                    },
                    end: {
                      month: 10,
                      year: 2023,
                    },
                    end_recalculated: 24286,
                    start_recalculated: 24278,
                  },
                },
                {
                  role: 'verladingsoperator',
                  employment_hours: 33,
                  description:
                    'Verantwoordelijk voor het efficiënt laden van tankwagens.\n- Verantwoordelijk voor de filtratie van het product.\n- Nauwkeurig bijhouden van documentatie en rapporten.\n- Kwaliteitscontroles van het eindproduct uitvoeren.',
                  company: {
                    name: 'Organik Kimya',
                  },
                  dates: {
                    start: {
                      month: 2,
                      year: 2024,
                    },
                    end: {
                      month: 8,
                      year: 2024,
                    },
                    end_recalculated: 24296,
                    start_recalculated: 24290,
                  },
                },
                {
                  role: 'machineoperator voedingsmiddelenindustrie (mechanisch operator)',
                  employment_hours: 33,
                  description:
                    'Bedienen en controleren van machines en apparatuur in de productie.\n- Verantwoordelijk voor 1e lijn onderhoud aan machines.\n- Verantwoordelijk voor het onderhoud aan machines.\n- Kwaliteitsmetingen uitvoeren van de producten.\n- Administratieve werkzaamheden verwerken in diverse programmas. ',
                  company: {
                    name: 'Euro-Caps B.V. ',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2024,
                    },
                    start_recalculated: 24297,
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'Roc Almere Buiten',
                  },
                  degree: 'horeca-assistent (mbo-1)',
                  dates: {
                    start: {
                      month: 7,
                      year: 2018,
                    },
                    end: {
                      month: 7,
                      year: 2019,
                    },
                    end_recalculated: 24235,
                    start_recalculated: 24223,
                  },
                  obtainedDegree: true,
                },
              ],
              skills: [
                {
                  europass: null,
                  name: 'Beslissingen nemen',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Anderen aansturen',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Samenwerken en overleggen',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Schrijven en rapporteren',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Vakdeskundig werken',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Logisch nadenken',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Leren',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Plannen en organiseren',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Betrouwbaar en eerlijk zijn',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Kwaliteit leveren',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Werken volgens de regels',
                  description: null,
                },
                {
                  europass: null,
                  name: 'Omgaan met spanning en tegenslag',
                  description: null,
                },
              ],
              certifications: [
                {
                  name: 'hazard analysis critical control points (haccp) (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 9,
                      year: 2024,
                    },
                    end: {
                      month: 9,
                      year: 2024,
                    },
                  },
                },
                {
                  name: 'heftruckchauffeur (praktijk) (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 3,
                      year: 2024,
                    },
                    end: {
                      month: 3,
                      year: 2024,
                    },
                  },
                },
                {
                  name: 'excel (basis) (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 3,
                      year: 2024,
                    },
                    end: {
                      month: 3,
                      year: 2024,
                    },
                  },
                },
                {
                  name: 'basisveiligheid (vca) (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 3,
                      year: 2024,
                    },
                    end: {
                      month: 3,
                      year: 2024,
                    },
                  },
                },
              ],
              languages: [
                {
                  proficiencyWritten: 'fluent',
                  name: 'Nederlands',
                  proficiency: 'fluent',
                },
                {
                  proficiencyWritten: 'fluent',
                  name: 'Engels',
                  proficiency: 'limited',
                },
                {
                  proficiencyWritten: 'limited',
                  name: 'Frans',
                  proficiency: 'limited',
                },
              ],
            },
            licenses: [
              {
                name: 'AM',
                type: 'driving_license_code',
              },
              {
                name: 'B',
                type: 'driving_license_code',
              },
            ],
            interests: [
              {
                name: 'Voetbal',
                description: null,
              },
              {
                name: 'Fitness',
                description: null,
              },
              {
                name: 'Klussen aan huis en tuin',
                description: null,
              },
              {
                name: 'Gamen',
                description: null,
              },
            ],
            contact_info: {
              email: ['creatorrv@icloud.com'],
              phone: ['0634158425'],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/7048711'],
            },
            location: {
              exists: true,
              raw: 'ROTTERDAM',
              coordinates: {
                lat: 51.89110264285714,
                lon: 4.494859834285715,
              },
              city: {
                short_name: '',
                long_name: '',
              },
              region: {
                level1: {
                  short_name: '',
                  long_name: '',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '3073CL',
              address: 'ROTTERDAM',
              place_id: 11613874,
              aggregate: [null, '', '', null, 'NL'],
            },
            sourceMeta: {
              updatedAt: '2025-11-06T09:12:46.732Z',
              changedAt: '2025-11-06T13:33:55.161Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-06T14:35:32.094Z',
            },
            preferences: {
              jobTitles: ['atex inspecteur, Inspecteur'],
              workHours: {
                min: 32,
                max: 40,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 10,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 24223,
                  last: 24235,
                  gap: 0,
                },
                professional: {
                  first: 24234,
                  last: null,
                  gap: 6,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'machineoperator voedingsmiddelenindustrie (mechanisch operator)',
            recent_job_titles: 'machineoperator voedingsmiddelenindustrie (mechanisch operator) verladingsoperator',
            past_job_titles:
              'logistiek medewerker magazijn procesoperator voedingsmiddelenindustrie (fieldoperator) mobiel beveiliger',
            insights: [
              {
                createdAt: '2025-11-06T13:33:55.151Z',
                newValue: null,
                _id: '690ca3c3a815c812793592a4',
                oldValue: {
                  month: 2,
                  year: 2025,
                },
                candidateId: 7048711,
                type: 'jobs_dates_end.changed',
                platform: 'werknl',
              },
              {
                createdAt: '2025-11-06T13:33:55.151Z',
                newValue: {
                  month: 2,
                  year: 2024,
                },
                _id: '690ca3c3a815c812793592a5',
                oldValue: {
                  month: 3,
                  year: 2024,
                },
                candidateId: 7048711,
                type: 'jobs_dates_start.changed',
                platform: 'werknl',
              },
              {
                createdAt: '2025-11-06T13:33:55.151Z',
                newValue: {
                  month: 2,
                  year: 2023,
                },
                _id: '690ca3c3a815c812793592a6',
                oldValue: {
                  month: 3,
                  year: 2023,
                },
                candidateId: 7048711,
                type: 'jobs_dates_start.changed',
                platform: 'werknl',
              },
            ],
            last_insight_date: '2025-11-06T13:33:55.151Z',
            new_candidate_date: '2023-07-19T04:01:08.201Z',
          },
          sort: [0, 1762436035151],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 7,
              duration_minutes: 24,
            },
            driving: {
              distance_km: 7,
              duration_minutes: 13,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'uitzendbureau-180430',
          _score: 19.21234,
          _ignored: [
            'location.city.long_name.completion',
            'location.aggregate.completion',
            'location.region.level2.long_name.completion',
          ],
          _source: {
            id: '180430',
            source: 'uitzendbureau',
            cvFileId: 'cv-2cd32252c53fdd2b046a7577e9cc143823fc070eb2694a2fd70904411a7dbfa7.doc',
            name: 'Garreth Werleman',
            contact_info: {
              uitzendbureau: ['https://www.uitzendbureau.nl/login/kandidaat/180430'],
              phone: ['Telefoonnummer: 06-59519379', '06-59519379', '304602.40014666'],
              email: ['G.G.Werleman@hotmail.com', 'ambrchri@wxs.nl'],
            },
            licenses: [
              {
                name: 'car',
                type: 'driving_license_name',
              },
              {
                name: 'forklift',
                type: 'driving_license_name',
              },
              {
                name: 'tractor',
                type: 'driving_license_name',
              },
              {
                name: 'moped',
                type: 'driving_license_name',
              },
            ],
            location: {
              exists: true,
              raw: 'Donckselaan 50 2983 LC Ridderkerk Nederland',
              coordinates: {
                lat: 51.88641774166666,
                lon: 4.59127055,
              },
              city: {
                short_name: '',
                long_name: '',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '2983LC',
              address: 'Ridderkerk, Zuid-Holland, Nederland, 2983LC, Nederland',
              place_id: 11603472,
              aggregate: [null, 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            preferences: {
              jobTitles: [
                'Logistiek',
                'Productie',
                'Technisch',
                'Ik ben op zoek naar een vaste baan als magazijnmedewerker, waarin mijn mix van ervaring, technisch inzicht en inzet tot zijn recht kan komen.',
              ],
              workHours: {
                min: '8',
                max: '40',
              },
              employmentType: ['full_time'],
              locations: ['rotterdam'],
              availability: '2013-07-18T00:00:00.000Z',
            },
            experiences: {
              jobs: [
                {
                  company: {
                    name: 'Renaissance Resort & Casino Hotel',
                  },
                  role: 'Bartender',
                  dates: {
                    start: {
                      month: 1,
                      year: 2004,
                    },
                    end: {
                      month: 1,
                      year: 2006,
                    },
                    start_recalculated: 24049,
                    end_recalculated: 24073,
                  },
                  description: '',
                },
                {
                  company: {
                    name: 'Atraco Boekhandel',
                  },
                  role: 'Magazijnmedewerker',
                  dates: {
                    start: {
                      month: 1,
                      year: 2006,
                    },
                    end: {
                      month: 1,
                      year: 2007,
                    },
                    start_recalculated: 24073,
                    end_recalculated: 24085,
                  },
                  description: 'orderpicker en logistiek',
                },
                {
                  company: {
                    name: 'Fantastic Gardens',
                  },
                  role: 'Magazijnmedewerker; Magazijnmedewerker',
                  dates: {
                    start: {
                      month: 1,
                      year: 2008,
                    },
                    end: {
                      month: 1,
                      year: 2009,
                    },
                    start_recalculated: 24097,
                    end_recalculated: 24109,
                  },
                  description: 'Heftruck en Pallettruck en Order Picking',
                },
                {
                  company: {
                    name: 'zelfstandig',
                  },
                  role: 'zelfstandige',
                  dates: {
                    start: {
                      month: 1,
                      year: 2009,
                    },
                    end: {
                      month: 1,
                      year: 2012,
                    },
                    start_recalculated: 24109,
                    end_recalculated: 24145,
                  },
                  description:
                    'als zelfstandige, ruime ervaring in Bouw en Wegenbouw\n(onderhouden gereedschap/machines, stucken van muren, cement storten, ijzervlechten, renovatie keuken of douche  (mede vervoeren materialen), diverse werkzaamheden in wegenbouw)',
                },
                {
                  company: {
                    name: 'zelfstandig',
                  },
                  role: 'zelfstandige klussen',
                  dates: {
                    start: {
                      month: 3,
                      year: 2012,
                    },
                    end: {
                      month: 6,
                      year: 2013,
                    },
                    start_recalculated: 24147,
                    end_recalculated: 24162,
                  },
                  description:
                    'diverse klussen, zoals badkamerrenovatie, gips plafonds plaatsen, stucken, gietvloer, tuinonderhoud',
                },
                {
                  company: {
                    name: 'CSB Batterijen',
                  },
                  role: 'Magazijnmedewerker',
                  dates: {
                    start: {
                      month: 6,
                      year: 2013,
                    },
                    end: {
                      month: 7,
                      year: 2013,
                    },
                    start_recalculated: 24162,
                    end_recalculated: 24163,
                  },
                  description:
                    'opladen en toetsen van diverse soorten batterijen, sealen/strappen van pallets  met batterijen, scannen in logistiek systeem, met heftruck en jackpallet vervoeren van pallets met batterijen.',
                },
              ],
              educations: [
                {
                  school: {
                    name: 'EPB Pariba',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 1999,
                    },
                    end: {
                      month: 1,
                      year: 2003,
                    },
                    start_recalculated: 23989,
                    end_recalculated: 24037,
                  },
                  degree: 'Economie (LBO)',
                },
                {
                  school: {
                    name: 'EPI',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2007,
                    },
                    end: {
                      month: 1,
                      year: 2007,
                    },
                    start_recalculated: 24085,
                    end_recalculated: 24085,
                  },
                  degree: 'Diploma Warehouse en Logistics (MBO)',
                },
                {
                  school: {
                    name: 'v-kam education',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2012,
                    },
                    end: {
                      month: 1,
                      year: 2012,
                    },
                    start_recalculated: 24145,
                    end_recalculated: 24145,
                  },
                  degree: 'Heftruck- Reachtruck (MBO)',
                },
                {
                  school: {
                    name: 'basecheck.nl',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2012,
                    },
                    end: {
                      month: 1,
                      year: 2012,
                    },
                    start_recalculated: 24145,
                    end_recalculated: 24145,
                  },
                  degree: 'VCA-Basis (MBO)',
                },
              ],
              relocations: [],
              certifications: [],
              skills: [
                {
                  name: 'duitvoeren van diverse werkzaamheden in de bouw, techniek,',
                },
                {
                  name: 'harde werker, collegiaal',
                },
                {
                  name: 'voorkomende werkzaamheden in magazijn',
                },
              ],
              languages: [
                {
                  name: 'Nederlands',
                  proficiency: 'excellent',
                  proficiencyWritten: 'excellent',
                },
                {
                  name: 'Engels',
                  proficiency: 'excellent',
                  proficiencyWritten: 'excellent',
                },
                {
                  name: 'Spaans',
                  proficiency: 'excellent',
                  proficiencyWritten: 'excellent',
                },
              ],
              honors: [],
              volunteer: [],
              licenses: [
                {
                  name: 'car',
                  type: 'driving_license_name',
                },
                {
                  name: 'forklift',
                  type: 'driving_license_name',
                },
                {
                  name: 'tractor',
                  type: 'driving_license_name',
                },
                {
                  name: 'moped',
                  type: 'driving_license_name',
                },
              ],
            },
            updatedDate: '2025-11-06T13:27:39.000Z',
            rr: {
              platform: 'uitzendbureau',
              updatedAt: '2025-11-06T13:27:44.129Z',
              updatedByCredentialUsername: 'roberto@recruitrobin.com',
              changedAt: '2025-11-06T13:27:44.147Z',
            },
            crawlerMeta: {
              platform: 'uitzendbureau',
              updatedAt: '2025-11-06T13:27:44.129Z',
              updatedByCredentialUsername: 'roberto@recruitrobin.com',
              changedAt: '2025-11-06T13:27:44.147Z',
            },
            sourceMeta: {
              updatedAt: '2025-11-06T13:27:39.000Z',
              changedAt: '2025-11-06T13:27:44.147Z',
            },
            dateOfBirth: '1985-08-28T00:00:00.000Z',
            description:
              'Garreth, Garvy Werleman heeft ervaring in:  Light Technical/Trades/Skilled Labor; en Hotel and Hospitality (Cooking and Food). Garreth, Garvy Werleman heeft 18 jaar werkervaring.',
            headline: 'Bartender',
            meta: {
              experience: {
                academic: {
                  first: 23989,
                  last: 24145,
                  gap: 108,
                },
                professional: {
                  first: 24049,
                  last: 24163,
                  gap: 14,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Magazijnmedewerker',
            recent_job_titles: 'Magazijnmedewerker zelfstandige klussen',
            past_job_titles: 'Bartender Magazijnmedewerker Magazijnmedewerker; Magazijnmedewerker zelfstandige',
            insights: [
              {
                _id: '690ca250a5ddfd9986b5a408',
                createdAt: '2025-11-06T13:27:44.136Z',
                platform: 'uitzendbureau',
                candidateId: '180430',
                type: 'candidate.added',
                newValue: null,
                oldValue: null,
              },
            ],
            last_insight_date: '2025-11-06T13:27:44.136Z',
            new_candidate_date: '2025-11-06T13:27:44.136Z',
          },
          sort: [0, 1762435664136],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 14,
              duration_minutes: 47,
            },
            driving: {
              distance_km: 16,
              duration_minutes: 16,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'uitzendbureau-360980',
          _score: 13.378768,
          _ignored: ['experiences.jobs.company.name.completion'],
          _source: {
            id: '360980',
            source: 'uitzendbureau',
            cvFileId: 'cv-62077169ad7a33a58a96997a9dd0ace482240f284a5ba9796972f86dded71673.docx',
            name: 'Edir Semedo',
            contact_info: {
              uitzendbureau: ['https://www.uitzendbureau.nl/login/kandidaat/360980'],
              phone: ['06-41585645', '0624724460', '0614907411'],
              email: ['kade_inc@hotmail.com'],
            },
            location: {
              exists: true,
              raw: ' 3014 RS Rotterdam Nederland',
              coordinates: {
                lat: 51.91801047777778,
                lon: 4.4680549111111105,
              },
              city: {
                short_name: 'Rotterdam',
                long_name: 'Rotterdam',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: 'Centrum',
                  long_name: 'Centrum',
                },
              },
              postal_code: '3014RS',
              address: 'Centrum, Rotterdam, Zuid-Holland, Nederland, 3014RS, Nederland',
              place_id: 11605664,
              aggregate: ['Rotterdam', 'Zuid-Holland', 'Centrum', 'Nederland', 'NL'],
            },
            preferences: {
              jobTitles: [],
              workHours: {
                min: '32',
                max: '40',
              },
              employmentType: ['full_time'],
              locations: ['Rotterdam'],
              availability: '2013-08-25T00:00:00.000Z',
            },
            experiences: {
              jobs: [
                {
                  company: {
                    name: 'Actie Sport',
                  },
                  role: 'Verkoopmedewerker',
                  dates: {
                    start: {
                      month: 1,
                      year: 2001,
                    },
                    end: {
                      month: 12,
                      year: 2002,
                    },
                    start_recalculated: 24013,
                    end_recalculated: 24036,
                  },
                  description:
                    'Functie: verkoop sportartikelen, bedienen kassa, voorraad beheer, afhandelen klachten, goederenontvangst & verzendklaar maken orders',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: 'Actie Sport',
                  },
                  role: 'Verkoopmedewerker',
                  dates: {
                    start: {
                      month: 1,
                      year: 2002,
                    },
                    end: {
                      month: 12,
                      year: 2002,
                    },
                    start_recalculated: 24025,
                    end_recalculated: 24036,
                  },
                  description:
                    'Functie: verkoop sportartikelen, bedienen kassa, voorraad beheer, afhandelen klachten, goederenontvangst & verzendklaar maken orders',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: '',
                  },
                  role: 'Postsorteerder',
                  dates: {
                    start: {
                      month: 1,
                      year: 2002,
                    },
                    end: {
                      month: 12,
                      year: 2004,
                    },
                    start_recalculated: 24025,
                    end_recalculated: 24060,
                  },
                  description: 'functie: Invoeren van poststukken in machines',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: 'KPN',
                  },
                  role: 'Callcenter medewerker Inbound',
                  dates: {
                    start: {
                      month: 1,
                      year: 2004,
                    },
                    end: {
                      month: 12,
                      year: 2008,
                    },
                    start_recalculated: 24049,
                    end_recalculated: 24108,
                  },
                  description:
                    'Functie: telefonische verkoop, administratieve verwerking van orders, telefonische advisering voorlichting, behalen van targets',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: 'ISS Eneco',
                  },
                  role: 'Callcenter medewerker Inbound',
                  dates: {
                    start: {
                      month: 1,
                      year: 2008,
                    },
                    end: {
                      month: 12,
                      year: 2009,
                    },
                    start_recalculated: 24097,
                    end_recalculated: 24120,
                  },
                  description:
                    'Functie: telefonische verkoop, administratieve verwerking van orders, telefonische advisering voorlichting, behalen van targets',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: 'Vanad KPN',
                  },
                  role: 'Callcenter medewerker Verkoop en informatie',
                  dates: {
                    start: {
                      month: 1,
                      year: 2009,
                    },
                    end: {
                      month: 12,
                      year: 2012,
                    },
                    start_recalculated: 24109,
                    end_recalculated: 24156,
                  },
                  description:
                    'Functie: telefonische verkoop, administratieve verwerking van orders, telefonische advisering voorlichting, behalen van targets',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: 'Thermen Holiday',
                  },
                  role: 'Zelfstandig kok',
                  dates: {
                    start: {
                      month: 1,
                      year: 2013,
                    },
                    end: {
                      month: 12,
                      year: 2014,
                    },
                    start_recalculated: 24157,
                    end_recalculated: 24180,
                  },
                  description: 'Functie: Het voorbereiden van gerechten, Het bijhouden van de voorraad',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: 'Nippon Express B.V',
                  },
                  role: 'Orderpicker',
                  dates: {
                    start: {
                      month: 1,
                      year: 2015,
                    },
                    end: {
                      month: 12,
                      year: 2015,
                    },
                    start_recalculated: 24181,
                    end_recalculated: 24192,
                  },
                  description: 'Functie: Controleren van kwantiteit, kwaliteit en etikettering van de orders',
                  location: {
                    raw: '',
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'Zuiderpark College',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 1996,
                    },
                    end: {
                      month: 1,
                      year: 2000,
                    },
                    start_recalculated: 23953,
                    end_recalculated: 24001,
                  },
                  degree: 'VMBO (MBO)',
                },
                {
                  school: {
                    name: 'Zadkine College',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2000,
                    },
                    end: {
                      month: 1,
                      year: 2001,
                    },
                    start_recalculated: 24001,
                    end_recalculated: 24013,
                  },
                  degree: 'Winkelassistent (MBO)',
                },
                {
                  school: {
                    name: 'Zadkine College',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2001,
                    },
                    end: {
                      month: 1,
                      year: 2002,
                    },
                    start_recalculated: 24013,
                    end_recalculated: 24025,
                  },
                  degree: 'Verkoopmedewerker 1 (MBO)',
                },
              ],
              relocations: [],
              certifications: [
                {
                  name: 'KPN V&I Nieuwe Stijl\t2009-2012\t certificaat behaald',
                },
                {
                  name: 'KPN V&I gespreksstructuur\t2009-2012\t certificaat behaald',
                },
              ],
              skills: [],
              languages: [],
              honors: [],
              volunteer: [],
              licenses: [],
            },
            updatedDate: '2025-11-06T12:57:01.000Z',
            rr: {
              platform: 'uitzendbureau',
              updatedAt: '2025-11-06T12:57:13.473Z',
              updatedByCredentialUsername: 'roberto@recruitrobin.com',
              changedAt: '2025-11-06T12:57:13.489Z',
            },
            crawlerMeta: {
              platform: 'uitzendbureau',
              updatedAt: '2025-11-06T12:57:13.473Z',
              updatedByCredentialUsername: 'roberto@recruitrobin.com',
              changedAt: '2025-11-06T12:57:13.489Z',
            },
            sourceMeta: {
              updatedAt: '2025-11-06T12:57:01.000Z',
              changedAt: '2025-11-06T12:57:13.489Z',
            },
            dateOfBirth: '1983-06-17T00:00:00.000Z',
            description:
              'Edir Semedo heeft ervaring in:  Sales; en Engineering (General Engineering; Air and Aerospace). Edir Semedo heeft 15 jaar werkervaring.',
            licenses: [],
            headline: 'Orderpicker',
            meta: {
              experience: {
                academic: {
                  first: 23953,
                  last: 24025,
                  gap: 0,
                },
                professional: {
                  first: 24013,
                  last: 24192,
                  gap: 2,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Orderpicker',
            recent_job_titles: 'Orderpicker Zelfstandig kok',
            past_job_titles:
              'Verkoopmedewerker Verkoopmedewerker Postsorteerder Callcenter medewerker Inbound Callcenter medewerker Inbound Callcenter medewerker Verkoop en informatie',
            insights: [
              {
                _id: '690c9b294151d6f8b358c25f',
                createdAt: '2025-11-06T12:57:13.479Z',
                platform: 'uitzendbureau',
                candidateId: '360980',
                type: 'candidate.added',
                newValue: null,
                oldValue: null,
              },
            ],
            last_insight_date: '2025-11-06T12:57:13.479Z',
            new_candidate_date: '2025-11-06T12:57:13.479Z',
          },
          sort: [0, 1762433833479],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 8,
              duration_minutes: 28,
            },
            driving: {
              distance_km: 10,
              duration_minutes: 17,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'cvt-AEMAAF_03esBlA3WBhmICZ-0loGbeSpEpULQ5bY',
          _score: 17.535742,
          _ignored: ['location.aggregate.completion', 'location.region.level2.long_name.completion'],
          _source: {
            id: 'AEMAAF_03esBlA3WBhmICZ-0loGbeSpEpULQ5bY',
            person_id: 'lorenzo-van-der-linden-3a319138b',
            username: 'lorenzo-van-der-linden-3a319138b',
            headline: '--',
            name: 'Lorenzo Van der linden',
            linkedin_uid: 'AEMAAF_03esBlA3WBhmICZ-0loGbeSpEpULQ5bY',
            source: 'cvt',
            experiences: {
              jobs: [
                {
                  role: 'BBL Metaalbewerking',
                  description: '',
                  company: {
                    name: 'VRR',
                  },
                  dates: {
                    start: {
                      month: 9,
                      year: 2012,
                    },
                    end: {
                      month: 7,
                      year: 2014,
                    },
                    start_recalculated: 24153,
                    end_recalculated: 24175,
                  },
                },
                {
                  role: 'Constructiebankwerker',
                  description: '',
                  company: {
                    name: 'VRR',
                  },
                  dates: {
                    start: {
                      month: 8,
                      year: 2014,
                    },
                    end: {
                      month: 12,
                      year: 2019,
                    },
                    start_recalculated: 24176,
                    end_recalculated: 24240,
                  },
                },
                {
                  role: 'Junior Magazijnmedewerker',
                  description: '\nSkills: Kardex-machine, Heftruckbesturing, Logistieke ondersteuning',
                  company: {
                    name: 'VRR',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2020,
                    },
                    start_recalculated: 24241,
                  },
                },
                {
                  role: 'Logistiek medewerker',
                  description: '\nSkills: Engels, Kardex-machine, Heftruckbesturing, Logistieke ondersteuning',
                  company: {
                    name: 'VRR',
                  },
                  dates: {
                    start_recalculated: 24311,
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'Davinci college',
                  },
                  degree: 'Constructie werker',
                  field: 'MBO 2',
                  dates: {
                    start: {
                      month: 9,
                      year: 2012,
                    },
                    end: {
                      month: 7,
                      year: 2014,
                    },
                    start_recalculated: 24153,
                    end_recalculated: 24175,
                  },
                },
              ],
              skills: [
                {
                  name: 'Engels',
                },
                {
                  name: 'Kardex-machine',
                },
                {
                  name: 'Heftruckbesturing',
                },
                {
                  name: 'Logistieke ondersteuning',
                },
              ],
              courses: [],
              languages: [],
              volunteer: [],
              certifications: [],
              relocations: [],
            },
            location: {
              exists: true,
              raw: 'Dordrecht, Zuid-Holland, Nederland',
              coordinates: {
                lat: 51.814429,
                lon: 4.6692438,
              },
              city: {
                short_name: 'Dordrecht',
                long_name: 'Dordrecht',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '3311XL',
              address: 'Dordrecht, Zuid-Holland, Nederland, 3311XL, Nederland',
              place_id: 105041,
              aggregate: ['Dordrecht', 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            contact_info: {
              cvt: ['https://www.linkedin.com/in/AEMAAF_03esBlA3WBhmICZ-0loGbeSpEpULQ5bY'],
            },
            industry: 'Transport, logistiek, supplychain en opslag',
            crawlerMeta: {
              updatedAt: '2025-11-06T12:14:15.318Z',
            },
            isVisible: true,
            openToNewOpportunities: true,
            linkedinVersion: 'v.2022',
            sourceMeta: {
              updatedAt: '2025-11-06T08:00:00.000Z',
              changedAt: '2025-11-06T12:14:15.782Z',
            },
            meta: {
              experience: {
                academic: {
                  first: 24153,
                  last: 24175,
                  gap: 0,
                },
                professional: {
                  first: 24153,
                  last: null,
                  gap: 2,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Logistiek medewerker',
            recent_job_titles: 'Logistiek medewerker Junior Magazijnmedewerker',
            past_job_titles: 'BBL Metaalbewerking Constructiebankwerker',
            insights: [
              {
                _id: '690c9117c21de8af753cff07',
                createdAt: '2025-11-06T12:14:15.710Z',
                platform: 'linkedin_classic',
                candidateId: 'AEMAAF_03esBlA3WBhmICZ-0loGbeSpEpULQ5bY',
                type: 'candidate.added',
                newValue: null,
                oldValue: null,
              },
            ],
            last_insight_date: '2025-11-06T12:14:15.710Z',
            new_candidate_date: '2025-11-06T12:14:15.710Z',
          },
          sort: [0, 1762431255710],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 23,
              duration_minutes: 75,
            },
            driving: {
              distance_km: 27,
              duration_minutes: 26,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'cvt-AEMAACmJwSIBwaSSNRR-PV5K16_aKQz69ped4HA',
          _score: 6.2540708,
          _ignored: ['location.aggregate.completion', 'location.region.level2.long_name.completion'],
          _source: {
            id: 'AEMAACmJwSIBwaSSNRR-PV5K16_aKQz69ped4HA',
            person_id: 'anouk-hoogendijk-b9647a175',
            username: 'anouk-hoogendijk-b9647a175',
            headline: 'International Business Studies, Zadkine Rotterdam',
            name: 'Anouk Hoogendijk',
            linkedin_uid: 'AEMAACmJwSIBwaSSNRR-PV5K16_aKQz69ped4HA',
            source: 'cvt',
            experiences: {
              jobs: [
                {
                  role: 'Bedieningsmedewerker',
                  description: '',
                  company: {
                    name: 'Watertuin schiedam',
                  },
                  dates: {
                    start: {
                      month: 10,
                      year: 2017,
                    },
                    end: {
                      month: 6,
                      year: 2021,
                    },
                    start_recalculated: 24214,
                    end_recalculated: 24258,
                  },
                },
                {
                  role: 'Logistics Agent',
                  description: '',
                  company: {
                    name: 'Shell Recharge Solutions',
                  },
                  dates: {
                    start: {
                      month: 6,
                      year: 2021,
                    },
                    end: {
                      month: 11,
                      year: 2023,
                    },
                    start_recalculated: 24258,
                    end_recalculated: 24287,
                  },
                },
                {
                  role: 'Inventory Specialist',
                  description: '',
                  company: {
                    name: 'Shell Recharge Solutions',
                  },
                  dates: {
                    start: {
                      month: 11,
                      year: 2023,
                    },
                    start_recalculated: 24287,
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'Lyceum Schravenlant',
                  },
                  degree: 'Havo',
                  field: 'Natuur en Gezondheid',
                  dates: {
                    start: {
                      year: 2010,
                    },
                    end: {
                      year: 2015,
                    },
                    start_recalculated: 24121,
                    end_recalculated: 24192,
                  },
                },
                {
                  school: {
                    name: 'Zadkine',
                  },
                  degree: 'mbo 4',
                  field: 'international business',
                  dates: {
                    start: {
                      year: 2018,
                    },
                    end: {
                      year: 2021,
                    },
                    start_recalculated: 24217,
                    end_recalculated: 24264,
                  },
                },
              ],
              skills: [
                {
                  name: 'Klantgerichte service',
                },
                {
                  name: 'Samenwerking',
                },
                {
                  name: 'Persoonlijke ontwikkeling',
                },
              ],
              courses: [],
              languages: [],
              volunteer: [],
              certifications: [],
              relocations: [],
            },
            location: {
              exists: true,
              raw: 'Maasland, Zuid-Holland, Nederland',
              coordinates: {
                lat: 51.947434200000004,
                lon: 4.278344093751938,
              },
              city: {
                short_name: 'Maasland',
                long_name: 'Maasland',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '',
              address: 'Maasland, Midden-Delfland, Zuid-Holland, Nederland',
              place_id: 11376594,
              aggregate: ['Maasland', 'Zuid-Holland', '', 'Nederland', 'NL'],
            },
            contact_info: {
              cvt: ['https://www.linkedin.com/in/AEMAACmJwSIBwaSSNRR-PV5K16_aKQz69ped4HA'],
            },
            industry: 'Restaurants',
            crawlerMeta: {
              updatedAt: '2025-11-06T12:14:12.403Z',
            },
            isVisible: true,
            openToNewOpportunities: true,
            linkedinVersion: 'v.2022',
            sourceMeta: {
              updatedAt: '2025-11-06T08:00:00.000Z',
              changedAt: '2025-11-06T12:14:12.716Z',
            },
            meta: {
              experience: {
                academic: {
                  first: 24121,
                  last: 24264,
                  gap: 25,
                },
                professional: {
                  first: 24214,
                  last: null,
                  gap: 0,
                },
                volunteer: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                keywords: [],
              },
            },
            current_job_title: 'Inventory Specialist',
            recent_job_titles: 'Inventory Specialist Logistics Agent',
            past_job_titles: 'Bedieningsmedewerker',
            insights: [
              {
                _id: '690c91144f8fae126e4e5b5a',
                createdAt: '2025-11-06T12:14:12.658Z',
                platform: 'linkedin_classic',
                candidateId: 'AEMAACmJwSIBwaSSNRR-PV5K16_aKQz69ped4HA',
                type: 'candidate.added',
                newValue: null,
                oldValue: null,
              },
            ],
            last_insight_date: '2025-11-06T12:14:12.658Z',
            new_candidate_date: '2025-11-06T12:14:12.658Z',
          },
          sort: [0, 1762431252658],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 20,
              duration_minutes: 66,
            },
            driving: {
              distance_km: 21,
              duration_minutes: 23,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'nvb-43b71892-95d2-11e6-995c-292c6307eed4',
          _score: 15.190796,
          _ignored: [
            'location.city.long_name.completion',
            'location.aggregate.completion',
            'location.region.level1.long_name.completion',
            'location.region.level2.long_name.completion',
          ],
          _source: {
            id: '43b71892-95d2-11e6-995c-292c6307eed4',
            experiences: {
              jobs: [
                {
                  role: 'Constructieschilder',
                  dates: {
                    start: {
                      month: 2,
                      year: 1999,
                    },
                    end: {
                      month: 6,
                      year: 1999,
                    },
                    end_recalculated: 23994,
                    start_recalculated: 23990,
                  },
                  company: {
                    name: 'Hudson (Boot',
                  },
                  id: '78702a64-6420-4119-a7e0-21e8c02c9efe',
                },
                {
                  role: 'Magazijnmedewerker',
                  dates: {
                    start: {
                      month: 4,
                      year: 2001,
                    },
                    end: {
                      month: 6,
                      year: 2001,
                    },
                    end_recalculated: 24018,
                    start_recalculated: 24016,
                  },
                  company: {
                    name: 'Excel Rotterdam',
                  },
                  id: '30e1a4e4-e2ee-4000-934e-c09b9e8c3f98',
                },
                {
                  role: 'Postsorteerder',
                  description: 'Sorteren van post',
                  dates: {
                    start: {
                      month: 9,
                      year: 2004,
                    },
                    end: {
                      month: 11,
                      year: 2004,
                    },
                    end_recalculated: 24059,
                    start_recalculated: 24057,
                  },
                  company: {
                    name: 'Tempo Team Rotterdam',
                  },
                  id: '2b7a0c2f-e1d8-41c7-88ec-cff5192a882e',
                },
                {
                  role: 'Medewerker spoelkeuken',
                  dates: {
                    start: {
                      month: 6,
                      year: 2005,
                    },
                    end: {
                      month: 7,
                      year: 2005,
                    },
                    end_recalculated: 24067,
                    start_recalculated: 24066,
                  },
                  company: {
                    name: 'Bazar Rotterdam',
                  },
                  id: 'f65f1439-d314-4ebe-ac45-ac9e80bee8f7',
                },
                {
                  role: 'Interieurverzorger',
                  dates: {
                    start: {
                      month: 7,
                      year: 2005,
                    },
                    end: {
                      month: 11,
                      year: 2005,
                    },
                    end_recalculated: 24071,
                    start_recalculated: 24067,
                  },
                  company: {
                    name: 'Detacheringsbureau Every Times Services BV Rotterdam',
                  },
                  id: '0d65f8fd-ca96-48f8-800a-4e0e45ad5e78',
                },
                {
                  role: 'Magazijnmedewerker',
                  description: 'Laden en lossen van containers',
                  dates: {
                    start: {
                      month: 10,
                      year: 2005,
                    },
                    end: {
                      month: 12,
                      year: 2005,
                    },
                    end_recalculated: 24072,
                    start_recalculated: 24070,
                  },
                  company: {
                    name: 'GLS Rotterdam',
                  },
                  id: '38a77377-5d48-47b7-9833-2416717460d4',
                },
                {
                  role: 'Magazijnmedewerker',
                  description: 'Orderpicken van diverse producten',
                  dates: {
                    start: {
                      month: 1,
                      year: 2006,
                    },
                    end: {
                      month: 4,
                      year: 2006,
                    },
                    end_recalculated: 24076,
                    start_recalculated: 24073,
                  },
                  company: {
                    name: 'Citronas Rotterdam',
                  },
                  id: 'cbd87c88-b39d-4bb3-84d8-7d4a5f1241fd',
                },
                {
                  role: 'Magazijnmedewerker',
                  description: 'Inpakken en controleren van verzendingen',
                  dates: {
                    start: {
                      month: 3,
                      year: 2010,
                    },
                    end: {
                      month: 6,
                      year: 2010,
                    },
                    end_recalculated: 24126,
                    start_recalculated: 24123,
                  },
                  company: {
                    name: 'Crocks Rotterdam',
                  },
                  id: 'edae92d8-1671-11e7-8e93-061b6f3ff9bd',
                },
                {
                  role: 'schoonmaken',
                  dates: {
                    start: {
                      month: 1,
                      year: 2014,
                    },
                    end: {
                      month: 4,
                      year: 2014,
                    },
                    end_recalculated: 24172,
                    start_recalculated: 24169,
                  },
                  company: {
                    name: 'Detacheringsbureau BV Aanbeeld Rotterdam',
                  },
                  id: '6b69c18d-c9c0-459e-a55b-0f3e0f98cd30',
                },
                {
                  role: 'schoonmaker medewerker',
                  description: 'alle werkzaamheden bij roteb',
                  dates: {
                    start: {
                      month: 1,
                      year: 2014,
                    },
                    end: {
                      month: 4,
                      year: 2014,
                    },
                    end_recalculated: 24172,
                    start_recalculated: 24169,
                  },
                  company: {
                    name: 'roteb',
                  },
                  id: 'd9f99559-26e6-4f8e-bec0-4133740cd798',
                },
                {
                  role: 'asbestsaneerder',
                  dates: {
                    start: {
                      month: 12,
                      year: 2018,
                    },
                    end: {
                      month: 1,
                      year: 2019,
                    },
                    end_recalculated: 24229,
                    start_recalculated: 24228,
                  },
                  company: {
                    name: 'Newhorizon',
                  },
                  id: '394a478c-e9f4-4a2f-a26c-faef139ef07f',
                },
                {
                  role: 'werkervaringsplaats magazijnmedewerker',
                  description: 'Ook bezorgen en ophalen',
                  dates: {
                    start: {
                      month: 11,
                      year: 2022,
                    },
                    start_recalculated: 24275,
                  },
                  company: {
                    name: 'Rataplan',
                  },
                  id: 'b09d3680-ccb2-42a9-9016-b589db18ef07',
                },
              ],
              educations: [
                {
                  field: 'Mavo',
                  school: {
                    name: 'Hildegardis Rotterdam',
                  },
                  description: '',
                  dates: {
                    start: {
                      month: 8,
                      year: 1992,
                    },
                    end: {
                      month: 7,
                      year: 1996,
                    },
                    end_recalculated: 23959,
                    start_recalculated: 23912,
                  },
                  id: '37c8bf50-b749-11e8-b04a-0242ac110005',
                  obtainedDegree: true,
                },
                {
                  field: 'Lastechnicus (MBO cursus)',
                  school: {
                    name: 'Albeda College Rotterdam',
                  },
                  degree: 'MBO',
                  description: '',
                  dates: {
                    start: {
                      month: 4,
                      year: 1998,
                    },
                    end: {
                      month: 8,
                      year: 1998,
                    },
                    end_recalculated: 23984,
                    start_recalculated: 23980,
                  },
                  id: '37c8bf00-b749-11e8-847a-0242ac110005',
                  obtainedDegree: true,
                },
                {
                  field: 'Schilder (MBO cursus)',
                  school: {
                    name: 'Albeda College Rotterdam',
                  },
                  degree: 'MBO',
                  description: '',
                  dates: {
                    start: {
                      month: 9,
                      year: 1998,
                    },
                    end: {
                      month: 2,
                      year: 1999,
                    },
                    end_recalculated: 23990,
                    start_recalculated: 23985,
                  },
                  id: '37c8beb0-b749-11e8-9e6e-0242ac110005',
                  obtainedDegree: true,
                },
                {
                  field: 'Heftruck chauffeur',
                  school: {
                    name: 'Albeda',
                  },
                  degree: 'MBO',
                  description: '',
                  dates: {
                    start: {
                      month: 1,
                      year: 2014,
                    },
                    end: {
                      month: 1,
                      year: 2014,
                    },
                    end_recalculated: 24169,
                    start_recalculated: 24169,
                  },
                  id: 'cb8b2cf6-5d38-11e9-ae94-0242ac110007',
                  obtainedDegree: true,
                },
                {
                  field: 'VCA',
                  school: {
                    name: 'Albeda',
                  },
                  degree: 'MBO',
                  description: '',
                  dates: {
                    start: {
                      month: 1,
                      year: 2014,
                    },
                    end: {
                      month: 1,
                      year: 2014,
                    },
                    end_recalculated: 24169,
                    start_recalculated: 24169,
                  },
                  id: '52425afe-5d38-11e9-9d2b-0242ac110007',
                  obtainedDegree: true,
                },
                {
                  field: 'Asbestsaneerder',
                  school: {
                    name: 'Newhorizin',
                  },
                  degree: 'MBO',
                  description: '',
                  dates: {
                    start: {
                      month: 1,
                      year: 2018,
                    },
                    end: {
                      month: 1,
                      year: 2019,
                    },
                    end_recalculated: 24229,
                    start_recalculated: 24217,
                  },
                  id: 'd1503a6a-5d37-11e9-b2b8-0242ac110007',
                  obtainedDegree: true,
                },
                {
                  field: 'Gasmeten',
                  school: {
                    name: 'Insignia',
                  },
                  degree: 'HBO',
                  description: '',
                  dates: {
                    start: {
                      month: 1,
                      year: 2019,
                    },
                    end: {
                      month: 1,
                      year: 2019,
                    },
                    end_recalculated: 24229,
                    start_recalculated: 24229,
                  },
                  id: '8088cd62-5d38-11e9-9277-0242ac110003',
                  obtainedDegree: true,
                },
                {
                  field: 'Kleine brandblusmiddelen',
                  school: {
                    name: 'Insignia',
                  },
                  degree: 'MBO',
                  description: '',
                  dates: {
                    start: {
                      month: 1,
                      year: 2019,
                    },
                    end: {
                      month: 1,
                      year: 2019,
                    },
                    end_recalculated: 24229,
                    start_recalculated: 24229,
                  },
                  id: '00405558-5d38-11e9-81b9-0242ac110003',
                  obtainedDegree: true,
                },
                {
                  field: 'Brandwacht',
                  school: {
                    name: 'Insignia',
                  },
                  degree: 'MBO',
                  description: '',
                  dates: {
                    start: {
                      month: 1,
                      year: 2019,
                    },
                    end: {
                      month: 1,
                      year: 2019,
                    },
                    end_recalculated: 24229,
                    start_recalculated: 24229,
                  },
                  id: 'ac505e98-5d37-11e9-b7c7-0242ac110003',
                  obtainedDegree: true,
                },
              ],
              languages: [
                {
                  name: 'NL',
                  proficiency: 'unknown',
                },
                {
                  name: 'EN',
                  proficiency: 'unknown',
                },
                {
                  proficiencyWritten: 'excellent',
                  name: 'Dutch',
                  proficiency: 'excellent',
                },
              ],
              skills: [],
              certifications: [],
            },
            interests: [],
            description: 'Leergierig',
            name: 'B Sow',
            industries: ['Productie/Uitvoerend', 'Inkoop/Logistiek/Transport', 'Techniek'],
            source: 'nvb',
            photos: [
              'https://d35ajla5icumre.cloudfront.net/profile-photos/43b71892-95d2-11e6-995c-292c6307eed4/4c80e48d-4096-4ace-abd6-2d08761b98f7.png',
            ],
            contact_info: {
              email: ['bocarsow@hotmail.com'],
              phone: ['0624792897'],
              nvb: [
                'https://www.persgroepemploymentsolutions.nl/recruiter/kandidaat/43b71892-95d2-11e6-995c-292c6307eed4',
              ],
            },
            location: {
              exists: true,
              raw: ' 3083RK   NL',
              coordinates: {
                lat: 51.88784122857142,
                lon: 4.4810006357142855,
              },
              city: {
                short_name: '',
                long_name: '',
              },
              region: {
                level1: {
                  short_name: '',
                  long_name: '',
                },
                level2: {
                  short_name: '',
                  long_name: '',
                },
              },
              postal_code: '3083RK',
              address: '3083RK',
              place_id: 11616625,
              aggregate: [null, '', '', null, 'NL'],
            },
            preferences: {
              workHours: {
                min: 32,
                max: 40,
              },
              jobTitles: ['allround magazijnmedewerker/heftruck chauffeur', 'brandwacht'],
              salaryRange: {
                min: 1750,
                max: 2500,
                currency: 'EUR',
                recurrence: 'monthly',
              },
              availability: 'immediate',
              employmentType: 'full_time',
              commuteDistance: {
                km: 10,
              },
            },
            migration: {
              status: 'migrating',
            },
            sourceMeta: {
              updatedAt: '2025-11-06T09:03:30.000Z',
              changedAt: '2025-11-06T09:03:42.323Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-06T09:03:42.314Z',
            },
            isVisible: true,
            cvFileId: null,
            meta: {
              experience: {
                academic: {
                  first: 23912,
                  last: 24229,
                  gap: 249,
                },
                professional: {
                  first: 23990,
                  last: null,
                  gap: 261,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'werkervaringsplaats magazijnmedewerker',
            recent_job_titles: 'werkervaringsplaats magazijnmedewerker asbestsaneerder',
            past_job_titles:
              'Constructieschilder Magazijnmedewerker Postsorteerder Medewerker spoelkeuken Interieurverzorger Magazijnmedewerker Magazijnmedewerker Magazijnmedewerker schoonmaken schoonmaker medewerker',
            headline: 'werkervaringsplaats magazijnmedewerker',
            insights: [
              {
                createdAt: '2022-12-07T04:25:16.713Z',
                newValue: {
                  role: 'Constructieschilder',
                  description: null,
                  dates: {
                    start: {
                      month: 2,
                      year: 1999,
                    },
                    end: {
                      month: 6,
                      year: 1999,
                    },
                  },
                  company: {
                    name: 'Hudson (Boot',
                  },
                  id: '78702a64-6420-4119-a7e0-21e8c02c9efe',
                },
                _id: '639015acf67aad7f04b52364',
                oldValue: null,
                candidateId: '43b71892-95d2-11e6-995c-292c6307eed4',
                type: 'jobs.added',
                platform: 'nvb',
              },
            ],
            last_insight_date: '2025-11-06T09:03:30.000Z',
            new_candidate_date: null,
            licenses: [],
          },
          sort: [0, 1762419810000],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 6,
              duration_minutes: 20,
            },
            driving: {
              distance_km: 6,
              duration_minutes: 11,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'debanensite-68b8c5df-4045-410c-8e46-58359e447cf5',
          _score: 15.566865,
          _ignored: ['location.aggregate.completion'],
          _source: {
            id: '68b8c5df-4045-410c-8e46-58359e447cf5',
            source: 'debanensite',
            cvFileId: 'cv-a33e6c58be39ca9ccc7ea3f139712da9c3539216e75ee09191d2a82f0947ff18.pdf',
            name: 'Eveline ',
            rr: {
              platform: 'debanensite',
              updatedAt: '2025-11-05T18:23:28.937Z',
              updatedByCredentialUsername: 'aron@recruitrobin.com',
              changedAt: '2025-11-05T18:23:28.969Z',
            },
            location: {
              raw: ' Rotterdam ',
              postal_code: null,
              city: {
                short_name: 'Rotterdam',
                long_name: 'Rotterdam',
              },
              exists: true,
              coordinates: {
                lat: 51.9244201,
                lon: 4.4777325,
              },
              aggregate: ['Rotterdam', '', 'NL'],
              region: {},
            },
            contact_info: {
              debanensite: ['https://werkgever.debanensite.nl/cvs/68b8c5df-4045-410c-8e46-58359e447cf5'],
              phone: ['0616702857'],
              email: ['e.emerenciana@live.nl'],
            },
            updatedDate: '2025-11-05T18:20:34.000Z',
            crawlerMeta: {
              platform: 'debanensite',
              updatedAt: '2025-11-05T18:23:28.937Z',
              updatedByCredentialUsername: 'aron@recruitrobin.com',
              changedAt: '2025-11-05T18:23:28.969Z',
            },
            sourceMeta: {
              updatedAt: '2025-11-05T18:20:34.000Z',
              changedAt: '2025-11-05T18:23:28.969Z',
            },
            description:
              'Eveline Emerenciana heeft ervaring in:  Administrative or Clerical (Document-centric; Messages and Contact); en Bookkeeping, Office Management (Bookeeping Tasks). Eveline Emerenciana heeft 9 jaar werkervaring.',
            experiences: {
              jobs: [
                {
                  company: {
                    name: 'K.E. Expeditie',
                  },
                  role: 'Administratief medewerkster',
                  dates: {
                    start: {
                      month: 6,
                      year: 2007,
                    },
                    end: {
                      month: 12,
                      year: 2007,
                    },
                    start_recalculated: 24090,
                    end_recalculated: 24096,
                  },
                  description:
                    'Taken\n* binnenkomende en uitgaande post verzorgen\n* afhandelen en versturen van faxen/ email\ninformeren van bezoekers',
                  location: {
                    raw: 'Rotterdam',
                  },
                },
                {
                  company: {
                    name: 'Bureau Brugbaan',
                  },
                  role: 'Boekhoudkundig medewerker',
                  dates: {
                    start: {
                      month: 8,
                      year: 2008,
                    },
                    end: {
                      month: 12,
                      year: 2008,
                    },
                    start_recalculated: 24104,
                    end_recalculated: 24108,
                  },
                  description:
                    'Taken\n* verzorgen van de crediteuren en debiteuren administratie\ncontroleren en verwerken van de facturen en bankmutaties\n* plannen en indelen van eigen werkzaamheden en eigen handelen evalueren en bijstellen',
                  location: {
                    raw: 'Rotterdam',
                  },
                },
                {
                  company: {
                    name: 'Scheepvaart en Transport College',
                  },
                  role: 'Front office medewerker',
                  dates: {
                    start: {
                      month: 7,
                      year: 2010,
                    },
                    end: {
                      month: 10,
                      year: 2010,
                    },
                    start_recalculated: 24127,
                    end_recalculated: 24130,
                  },
                  description:
                    'Taken\n* informeren van bezoekers en studenten aan de balie\ntelefoon centraal beheer\n* bezoekers bij de ingang van de parkeergarage doorverwijzen naar de juiste parkeerplaats\n* reserveringen maken van de parkeerplaatsen',
                  location: {
                    raw: 'Rotterdam',
                  },
                },
                {
                  company: {
                    name: 'Nemo fish & chips',
                  },
                  role: 'Medewerkster snack-/fastfoodmedewerker',
                  dates: {
                    start: {
                      month: 6,
                      year: 2014,
                    },
                    end: {
                      month: 1,
                      year: 2015,
                    },
                    start_recalculated: 24174,
                    end_recalculated: 24181,
                  },
                  description:
                    'Taken\n* voorbereiden en schoonmaken van sea food\n* bijvullen van de preps voor de nachtploeg\nfrituren\n* kassa bedienen\n\nCateringmedewerker /servicemedewerker\nStadhuis\nfebruari 2013 tot juni 2013\n\nTaken\n* assisteren bij het het voorbereiden van maaltijden\n* verzorgen van de presentatie van de buffetten\nkassa bedienen',
                  location: {
                    raw: 'Rotterdam',
                  },
                },
                {
                  company: {
                    name: 'Buurthuis de Arend',
                  },
                  role: 'Sportinstructeur',
                  dates: {
                    start: {
                      month: 5,
                      year: 2015,
                    },
                    end: {
                      month: 9,
                      year: 2016,
                    },
                    start_recalculated: 24185,
                    end_recalculated: 24201,
                  },
                  description: 'Taken\n* Sportoefeningen voordoen en begeleiden tijdens deze Sportoefeningen',
                  location: {
                    raw: 'Rotterdam',
                  },
                },
                {
                  company: {
                    name: 'Synlab Laboratorium',
                  },
                  role: 'Analist 4 productiemedewerker',
                  dates: {
                    start: {
                      month: 7,
                      year: 2017,
                    },
                    end: {
                      month: 6,
                      year: 2019,
                    },
                    start_recalculated: 24211,
                    end_recalculated: 24234,
                  },
                  description: 'Taken\n* Bewerken en registreren van monsters',
                  location: {
                    raw: 'Rotterdam Hoogvliet',
                  },
                },
                {
                  company: {
                    name: 'Santrade',
                  },
                  role: 'Magazijnmedewerker/orderpicker',
                  dates: {
                    start: {
                      month: 9,
                      year: 2019,
                    },
                    end: {
                      month: 10,
                      year: 2019,
                    },
                    start_recalculated: 24237,
                    end_recalculated: 24238,
                  },
                  description: 'Taken\n* Orderpicken van schroeven en bouten',
                  location: {
                    raw: 'Schiedam',
                  },
                },
                {
                  company: {
                    name: 'Santon',
                  },
                  role: 'Assemblagemedewerker',
                  dates: {
                    start: {
                      month: 10,
                      year: 2019,
                    },
                    end: {
                      month: 12,
                      year: 2019,
                    },
                    start_recalculated: 24238,
                    end_recalculated: 24240,
                  },
                  description: 'Taken\n* Assembleren van schakelaars\n\n\n* Bedienen van machines bij storingen',
                  location: {
                    raw: '',
                  },
                },
                {
                  company: {
                    name: 'Toko Dushi Ambiente',
                  },
                  role: 'Verkoopmedewerker',
                  dates: {
                    start: {
                      month: 9,
                      year: 2021,
                    },
                    end: {
                      month: 2,
                      year: 2022,
                    },
                    start_recalculated: 24261,
                    end_recalculated: 24266,
                  },
                  description:
                    'Taken\n* vragen van klanten beantwoorden\n* advies geven\n* werking uitleggen van producten\n* producten afrekenen\n* winkel netjes houden\n* goederen uitpakken\n* voorraad aanvullen\n* toezicht houden\n* etalage inrichten\n* administratie bijhouden\n* winkel openen en afsluiten\n* rapporteren aan eigenaar/manager',
                  location: {
                    raw: 'Schiedam',
                  },
                },
                {
                  company: {
                    name: 'Elis-Schiedam',
                  },
                  role: 'Productiemedewerker',
                  dates: {
                    start: {
                      month: 7,
                      year: 2022,
                    },
                    end: {
                      month: 6,
                      year: 2025,
                    },
                    start_recalculated: 24271,
                    end_recalculated: 24306,
                  },
                  description: 'Textiel vouwen en inpakken',
                  location: {
                    raw: 'Schiedam',
                  },
                },
                {
                  company: {
                    name: 'Boekenbalie BV',
                  },
                  role: 'Allround magazijnmedewerk(st)er',
                  dates: {
                    start: {
                      month: 8,
                      year: 2025,
                    },
                    start_recalculated: 24308,
                  },
                  description: 'Boeken regristreren, sorteren, inpakken en verzendklaar maken',
                  location: {
                    raw: 'Rotterdam',
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'Abraham de Veer College',
                  },
                  dates: {
                    start: {
                      month: 4,
                      year: 2006,
                    },
                    end: {
                      month: 5,
                      year: 2007,
                    },
                    start_recalculated: 24076,
                    end_recalculated: 24089,
                  },
                  degree: 'MAVO',
                },
                {
                  school: {
                    name: 'Zadkine-Rotterdam Centrum',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2013,
                    },
                    end: {
                      month: 1,
                      year: 2014,
                    },
                    start_recalculated: 24157,
                    end_recalculated: 24169,
                  },
                  degree: 'MBO',
                },
              ],
              languages: [],
            },
            licenses: [],
            headline: 'Allround magazijnmedewerk(st)er',
            meta: {
              experience: {
                academic: {
                  first: 24076,
                  last: 24169,
                  gap: 68,
                },
                professional: {
                  first: 24090,
                  last: null,
                  gap: 116,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'Allround magazijnmedewerk(st)er',
            recent_job_titles: 'Allround magazijnmedewerk(st)er Productiemedewerker',
            past_job_titles:
              'Administratief medewerkster Boekhoudkundig medewerker Front office medewerker Medewerkster snack-/fastfoodmedewerker Sportinstructeur Analist 4 productiemedewerker Magazijnmedewerker/orderpicker Assemblagemedewerker Verkoopmedewerker',
            insights: [
              {
                _id: '690b96200d938c81b1584423',
                createdAt: '2025-11-05T18:23:28.960Z',
                platform: 'debanensite',
                candidateId: '68b8c5df-4045-410c-8e46-58359e447cf5',
                type: 'candidate.added',
                newValue: null,
                oldValue: null,
              },
            ],
            last_insight_date: '2025-11-05T18:20:34.000Z',
            new_candidate_date: '2025-11-05T18:23:28.960Z',
          },
          sort: [0, 1762366834000],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 10,
              duration_minutes: 32,
            },
            driving: {
              distance_km: 11,
              duration_minutes: 18,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-4642229',
          _score: 15.451167,
          _source: {
            id: 4642229,
            source: 'werknl',
            name: 'Steven Denny Stam',
            headline: 'Postbode',
            description:
              'Ik ben inzetbaar voor verschillende functies.Ben presentatief,gauw begrijpend en handelend.De functies kunnen uiteenlopen van koffiezetten tot beveiligingsambtenaar.',
            experiences: {
              jobs: [],
              educations: [
                {
                  school: {
                    name: 'CSG HENEGOUWER',
                  },
                  degree: 'mavo',
                  dates: {
                    start: {
                      month: 8,
                      year: 1977,
                    },
                    end: {
                      month: 7,
                      year: 1982,
                    },
                    end_recalculated: 23791,
                    start_recalculated: 23732,
                  },
                  obtainedDegree: true,
                },
                {
                  degree: 'elektrotechniek (mts)',
                  dates: {
                    start: {
                      month: 8,
                      year: 1982,
                    },
                    end: {
                      month: 7,
                      year: 1984,
                    },
                    end_recalculated: 23815,
                    start_recalculated: 23792,
                  },
                  obtainedDegree: false,
                },
              ],
              skills: [
                {
                  europass: null,
                  name: 'Succesvol willen zijn',
                  description: 'Zeker willen opgroeien om goede ambities en eens mijn eigen bedrijf te willen starten.',
                },
                {
                  europass: null,
                  name: 'Werken volgens de regels',
                  description: 'Kunnen indenken en inwerken met goede inzet.',
                },
                {
                  europass: null,
                  name: 'Samenwerken en overleggen',
                  description: 'Goed in verstandhouding dat invloed kan hebben op een werkpartner',
                },
                {
                  europass: null,
                  name: 'Leren',
                  description: 'Leren volgens het stappenplan van een bedrijf wat mijn prestaties verbeteren.',
                },
                {
                  europass: null,
                  name: 'Anderen begeleiden',
                  description: 'In zoverre ik gegroeid ben in een bedrijf,kan ik mijn kunnen aan anderen overbrengen.',
                },
                {
                  europass: null,
                  name: 'Aandacht voor anderen',
                  description: 'Kan vrijwel goed luisteren naar ideeën van anderen en er lering uittrekken.',
                },
                {
                  europass: null,
                  name: 'Beslissingen nemen',
                  description:
                    'Wel of niet mee eens zijn met voorgenomen veranderingen of stappen en over beslissingen denken',
                },
              ],
              certifications: [],
              languages: [
                {
                  proficiencyWritten: 'limited',
                  name: 'Nederlands',
                  proficiency: 'unknown',
                },
              ],
            },
            licenses: [],
            interests: [
              {
                name: 'lopen,fietsen,gezelschapspelen',
                description:
                  'Lees veel over de moderne tijd om mij te kunnen inleven in de maatschappelijke vriendendienst die er te bieden is.',
              },
            ],
            contact_info: {
              email: ['stevendenny.stam@gmail.com'],
              phone: [],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/4642229'],
            },
            location: {
              exists: true,
              raw: 'ROTTERDAM',
              coordinates: {
                lat: 51.90585882553191,
                lon: 4.447037204255319,
              },
              city: {
                short_name: 'Rotterdam',
                long_name: 'Rotterdam',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: 'Delfshaven',
                  long_name: 'Delfshaven',
                },
              },
              postal_code: '3025XT',
              address: 'ROTTERDAM',
              place_id: 11606949,
              aggregate: ['Rotterdam', 'Zuid-Holland', 'Delfshaven', 'Nederland', 'NL'],
            },
            sourceMeta: {
              updatedAt: '2025-11-05T16:55:10.563Z',
              changedAt: '2025-11-05T16:56:17.942Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-05T16:56:17.925Z',
            },
            preferences: {
              jobTitles: [
                'grondwerker grond-, weg- en waterbouw (gww), postbesteller',
                'Magazijnmedewerker, postbesteller',
              ],
              workHours: {
                min: 15,
                max: 36,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 10,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 23732,
                  last: 23815,
                  gap: 1,
                },
                professional: {
                  first: 0,
                  last: 0,
                  gap: 0,
                },
                volunteer: {},
                keywords: [],
              },
            },
            recent_job_titles: ' ',
            past_job_titles: '',
            insights: [],
            last_insight_date: '2025-11-05T16:55:10.563Z',
            new_candidate_date: null,
          },
          sort: [0, 1762361710563],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 8,
              duration_minutes: 28,
            },
            driving: {
              distance_km: 10,
              duration_minutes: 16,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'debanensite-8f616194-a87c-4084-94bd-f88b1f227121',
          _score: 14.559996,
          _ignored: ['location.aggregate.completion'],
          _source: {
            id: '8f616194-a87c-4084-94bd-f88b1f227121',
            source: 'debanensite',
            cvFileId: 'cv-91e72f67e59234b3caf8c314b9001c2e0baea2630ffce24f31470a7bd15c0d09.pdf',
            name: 'Anino Latuheru',
            rr: {
              platform: 'debanensite',
              updatedAt: '2025-11-05T16:35:31.531Z',
              updatedByCredentialUsername: 'aron@recruitrobin.com',
              changedAt: '2025-11-05T16:35:31.596Z',
            },
            location: {
              raw: ' Moordrecht ',
              postal_code: null,
              city: {
                short_name: 'Moordrecht',
                long_name: 'Moordrecht',
              },
              exists: true,
              coordinates: {
                lat: 51.9873863,
                lon: 4.6689582,
              },
              aggregate: ['Moordrecht', '', 'NL'],
              region: {},
            },
            contact_info: {
              debanensite: ['https://werkgever.debanensite.nl/cvs/8f616194-a87c-4084-94bd-f88b1f227121'],
              phone: ['0615314036'],
              email: ['anino99@outlook.com'],
            },
            updatedDate: '2025-11-05T16:35:20.000Z',
            crawlerMeta: {
              platform: 'debanensite',
              updatedAt: '2025-11-05T16:35:31.531Z',
              updatedByCredentialUsername: 'aron@recruitrobin.com',
              changedAt: '2025-11-05T16:35:31.596Z',
            },
            sourceMeta: {
              updatedAt: '2025-11-05T16:35:20.000Z',
              changedAt: '2025-11-05T16:35:31.596Z',
            },
            description:
              'Anino Latuheru heeft ervaring in:  Administrative or Clerical (Admin; Document-centric); en Finance (Securities). Anino Latuheru blijkt van een ervaren niveau te zijn met ongeveer 2 jaar ervaring.',
            experiences: {
              jobs: [
                {
                  role: 'Schoonmaker',
                  description: 'Vakantie baan\nSchoonmaak werk',
                  company: {
                    name: 'Compaxo Vleeswaren',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2018,
                    },
                    end: {
                      month: 9,
                      year: 2018,
                    },
                    end_recalculated: 24225,
                    start_recalculated: 24223,
                  },
                  location: {
                    raw: 'Gouda',
                  },
                },
                {
                  role: 'Administratief medewerker',
                  description: 'Vakantie baan\nData entry',
                  company: {
                    name: 'Mika Distribution',
                  },
                  dates: {
                    start: {
                      month: 7,
                      year: 2019,
                    },
                    end: {
                      month: 8,
                      year: 2019,
                    },
                    end_recalculated: 24236,
                    start_recalculated: 24235,
                  },
                  location: {
                    raw: 'Lisse',
                  },
                },
                {
                  role: 'Logistiek medewerker',
                  description: 'Tijdelijke invaller\nOrder pick\nInpak werk',
                  company: {
                    name: 'Krabbendam Kadoverpakking',
                  },
                  dates: {
                    start: {
                      month: 10,
                      year: 2020,
                    },
                    end: {
                      month: 12,
                      year: 2020,
                    },
                    end_recalculated: 24252,
                    start_recalculated: 24250,
                  },
                  location: {
                    raw: 'Nieuwerkerk',
                  },
                },
                {
                  role: 'Administratief medewerker',
                  description: 'Order administratie\nOrder invoer\nKlantcontact',
                  company: {
                    name: 'Snel Logistics',
                  },
                  dates: {
                    start: {
                      month: 10,
                      year: 2021,
                    },
                    end: {
                      month: 2,
                      year: 2022,
                    },
                    end_recalculated: 24266,
                    start_recalculated: 24262,
                  },
                  location: {
                    raw: 'Woerden',
                  },
                },
                {
                  role: 'Administratief medewerker',
                  description: 'Order administratie / Data entry\nAnalyse rapporten opstellen\nKlantcontact via mail',
                  company: {
                    name: 'Normec Aquaserva',
                  },
                  dates: {
                    start: {
                      month: 5,
                      year: 2022,
                    },
                    end: {
                      month: 9,
                      year: 2023,
                    },
                    end_recalculated: 24285,
                    start_recalculated: 24269,
                  },
                  location: {
                    raw: 'Rotterdam',
                  },
                },
              ],
              educations: [
                {
                  school: {
                    name: 'ROC Zadkine',
                  },
                  degree: 'MBO Niveau 2',
                  dates: {
                    start: {
                      month: 8,
                      year: 2016,
                    },
                    end: {
                      month: 5,
                      year: 2018,
                    },
                    end_recalculated: 24221,
                    start_recalculated: 24200,
                  },
                },
                {
                  field: 'Albeda',
                  school: {
                    name: 'ROC',
                  },
                  degree: 'MBO Niveau 2',
                  dates: {
                    start: {
                      month: 9,
                      year: 2018,
                    },
                    end: {
                      month: 5,
                      year: 2019,
                    },
                    end_recalculated: 24233,
                    start_recalculated: 24225,
                  },
                },
              ],
              languages: [],
            },
            licenses: [],
            headline: 'Administratief medewerker',
            meta: {
              experience: {
                academic: {
                  first: 24200,
                  last: 24233,
                  gap: 4,
                },
                professional: {
                  first: 24223,
                  last: 24285,
                  gap: 37,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'Administratief medewerker',
            recent_job_titles: 'Administratief medewerker Administratief medewerker',
            past_job_titles: 'Schoonmaker Administratief medewerker Logistiek medewerker',
            insights: [
              {
                createdAt: '2025-05-02T15:46:52.337Z',
                newValue: null,
                _id: '6814e8ec88fab575140ae8a0',
                oldValue: null,
                candidateId: '8f616194-a87c-4084-94bd-f88b1f227121',
                type: 'candidate.added',
                platform: 'debanensite',
              },
            ],
            last_insight_date: '2025-11-05T16:35:20.000Z',
            new_candidate_date: '2025-05-02T15:46:52.337Z',
          },
          sort: [0, 1762360520000],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 26,
              duration_minutes: 83,
            },
            driving: {
              distance_km: 36,
              duration_minutes: 32,
            },
          },
        } as CandidateDto,
        {
          _index: 'robin_cv_index_20220926',
          _id: 'werknl-6918318',
          _score: 11.11558,
          _source: {
            id: 6918318,
            source: 'werknl',
            name: 'René Wuurman',
            headline: 'Heftruckchauffeur',
            description:
              'Ik ben een rustige en vriendelijke man die goed met zijn handen kan werken.\nIn mijn werk pak ik zaken makkelijk op,leer goed uit de praktijk en heb een \ngoed technisch inzicht.\nDaarnaast kan ik zowel goed zelfstandig als in team verband mijn werkzaamheden\nuitvoeren.\nVerder ben ik betrokken, flexibel ( geen 9 tot 5 mentaliteit),voer mijn \nwerkzaamheden nauwkeurig uit en ik ben erg  leergier en pak dingen snel op.\n',
            experiences: {
              jobs: [
                {
                  role: 'reachtruckchauffeur',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'schenker db',
                  },
                  dates: {
                    start: {
                      month: 5,
                      year: 2017,
                    },
                    end: {
                      month: 12,
                      year: 2017,
                    },
                    end_recalculated: 24216,
                    start_recalculated: 24209,
                  },
                },
                {
                  role: 'monteur computerbekabeling',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'bam',
                  },
                  dates: {
                    start: {
                      month: 4,
                      year: 2018,
                    },
                    end: {
                      month: 7,
                      year: 2018,
                    },
                    end_recalculated: 24223,
                    start_recalculated: 24220,
                  },
                },
                {
                  role: 'Magazijnmedewerker',
                  employment_hours: 25,
                  description: null,
                  company: {
                    name: 'gemeente spijkenisse',
                  },
                  dates: {
                    start: {
                      month: 8,
                      year: 2018,
                    },
                    end: {
                      month: 1,
                      year: 2019,
                    },
                    end_recalculated: 24229,
                    start_recalculated: 24224,
                  },
                },
                {
                  role: 'Magazijnmedewerker',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'akzo nobel',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2019,
                    },
                    end: {
                      month: 5,
                      year: 2019,
                    },
                    end_recalculated: 24233,
                    start_recalculated: 24229,
                  },
                },
                {
                  role: 'Magazijnmedewerker',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'startpeople(geodis)',
                  },
                  dates: {
                    start: {
                      month: 6,
                      year: 2019,
                    },
                    end: {
                      month: 1,
                      year: 2020,
                    },
                    end_recalculated: 24241,
                    start_recalculated: 24234,
                  },
                },
                {
                  role: 'reachtruckchauffeur',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'stedin',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2020,
                    },
                    end: {
                      month: 2,
                      year: 2020,
                    },
                    end_recalculated: 24242,
                    start_recalculated: 24241,
                  },
                },
                {
                  role: 'monsternemer (industrie)',
                  employment_hours: 40,
                  description:
                    'alle voorkomende magazijn werkzaamheden\nhet afnemen en tappen van chemische produkten\nde produckten registreren in de pc\nsamples en monsters transporteren naar de klanten in heel nederland',
                  company: {
                    name: 'sgs',
                  },
                  dates: {
                    start: {
                      month: 4,
                      year: 2021,
                    },
                    end: {
                      month: 9,
                      year: 2022,
                    },
                    end_recalculated: 24273,
                    start_recalculated: 24256,
                  },
                } as CandidateDto['_source']['experiences']['jobs'][number],
                {
                  role: 'bakwagenchauffeur regionaal transport',
                  employment_hours: 40,
                  description:
                    'goederen bezorgen \norders picken verzenden inpakken controleren \nladen lossen met heftruck\nreachtruck werkzaamheden',
                  company: {
                    name: 'vd zanden',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2023,
                    },
                    end: {
                      month: 2,
                      year: 2024,
                    },
                    end_recalculated: 24290,
                    start_recalculated: 24277,
                  },
                },
                {
                  role: 'chauffeur bestelauto',
                  employment_hours: 40,
                  description:
                    'bezorgen van orders naar verschillende locaties door heel nederland\nalle voorkomende logistieke werkzaamheden\nklanten contact onderhouden\nschoonmaak en reparatie onderhoud op de vestiging\n',
                  company: {
                    name: 'spie',
                  },
                  dates: {
                    start: {
                      month: 1,
                      year: 2025,
                    },
                    end: {
                      month: 10,
                      year: 2025,
                    },
                    end_recalculated: 24310,
                    start_recalculated: 24301,
                  },
                },
              ],
              educations: [
                {
                  degree: 'brood- en banketbakken (lts/vbo)',
                  dates: {
                    start: {
                      month: 1,
                      year: 1988,
                    },
                    end: {
                      month: 12,
                      year: 1992,
                    },
                    end_recalculated: 23916,
                    start_recalculated: 23857,
                  },
                  obtainedDegree: true,
                } as CandidateDto['_source']['experiences']['educations'][number],
                {
                  degree: 'koken/serveren (lts/vbo)',
                  dates: {
                    start: {
                      month: 1,
                      year: 1993,
                    },
                    end: {
                      month: 12,
                      year: 1993,
                    },
                    end_recalculated: 23928,
                    start_recalculated: 23917,
                  },
                  obtainedDegree: true,
                },
                {
                  degree: 'managementassistent (mbo)',
                  dates: {
                    start: {
                      month: 1,
                      year: 1994,
                    },
                    end: {
                      month: 12,
                      year: 1996,
                    },
                    end_recalculated: 23964,
                    start_recalculated: 23929,
                  },
                  obtainedDegree: true,
                },
                {
                  degree: 'elektrisch lassen (beginners) (vbo)',
                  dates: {
                    start: {
                      month: 5,
                      year: 1998,
                    },
                    end: {
                      month: 5,
                      year: 1998,
                    },
                    end_recalculated: 23981,
                    start_recalculated: 23981,
                  },
                  obtainedDegree: true,
                },
                {
                  degree: 'logistiek medewerker (groothandel) (mbo-2)',
                  dates: {
                    start: {
                      month: 2,
                      year: 2017,
                    },
                    end: {
                      month: 5,
                      year: 2018,
                    },
                    end_recalculated: 24221,
                    start_recalculated: 24206,
                  },
                  obtainedDegree: true,
                },
              ],
              skills: [
                {
                  europass: null,
                  name: 'Beslissingen nemen',
                  description: 'Beslissen en activiteiten initiëren',
                },
                {
                  europass: null,
                  name: 'Anderen aansturen',
                  description: 'Aansturen',
                },
                {
                  europass: null,
                  name: 'Vernieuwen en vooruit denken',
                  description: 'Creëren en innoveren',
                },
                {
                  europass: null,
                  name: 'Plannen en organiseren',
                  description: 'Plannen en organiseren',
                },
                {
                  europass: null,
                  name: 'Kwaliteit leveren',
                  description: 'Kwaliteit leveren',
                },
              ],
              certifications: [
                {
                  name: 'hef- of reachtruckchauffeur (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 6,
                      year: 2011,
                    },
                    end: {
                      month: 6,
                      year: 2011,
                    },
                  },
                },
                {
                  name: 'basisveiligheid (vca) (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 6,
                      year: 2009,
                    },
                    end: {
                      month: 6,
                      year: 2009,
                    },
                  },
                },
                {
                  name: 'hef- of reachtruckchauffeur (cursus)',
                  description: null,
                  dates: {
                    start: {
                      month: 1,
                      year: 1999,
                    },
                    end: {
                      month: 1,
                      year: 1999,
                    },
                  },
                },
              ],
              languages: [
                {
                  proficiencyWritten: 'fluent',
                  name: 'Nederlands',
                  proficiency: 'fluent',
                },
                {
                  proficiencyWritten: 'limited',
                  name: 'Duits',
                  proficiency: 'limited',
                },
                {
                  proficiencyWritten: 'fluent',
                  name: 'Engels',
                  proficiency: 'fluent',
                },
              ],
            },
            licenses: [
              {
                name: 'B',
                type: 'driving_license_code',
              },
            ],
            interests: [
              {
                name: 'muziek',
                description: null,
              },
              {
                name: 'sport',
                description: null,
              },
              {
                name: 'pokeren',
                description: null,
              },
              {
                name: 'pc',
                description: null,
              },
              {
                name: 'lezen',
                description: null,
              },
            ],
            contact_info: {
              email: ['rene-wuurman@hotmail.com'],
              phone: ['0683160102'],
              werknl: ['https://www.werk.nl/werkgevers/mijn-werknl/cvs-zoeken/6918318'],
            },
            location: {
              exists: true,
              raw: 'Spijkenisse',
              coordinates: {
                lat: 51.830200239999996,
                lon: 4.327869213333333,
              },
              city: {
                short_name: 'Spijkenisse',
                long_name: 'Spijkenisse',
              },
              region: {
                level1: {
                  short_name: 'Zuid-Holland',
                  long_name: 'Zuid-Holland',
                },
                level2: {
                  short_name: 'De Akkers',
                  long_name: 'De Akkers',
                },
              },
              postal_code: '3206PL',
              address: 'Spijkenisse',
              place_id: 11624729,
              aggregate: ['Spijkenisse', 'Zuid-Holland', 'De Akkers', 'Nederland', 'NL'],
            },
            sourceMeta: {
              updatedAt: '2025-11-05T12:11:54.645Z',
              changedAt: '2025-11-05T12:20:19.464Z',
            },
            crawlerMeta: {
              updatedAt: '2025-11-05T12:20:19.442Z',
            },
            preferences: {
              jobTitles: [
                'chauffeur klein rijbewijs (koerier), chauffeur rijbewijs b',
                'chauffeur klein rijbewijs (koerier), koerier',
              ],
              workHours: {
                min: 40,
                max: 60,
              },
              employmentType: 'full_time',
              commuteDistance: {
                km: 10,
              },
            },
            meta: {
              experience: {
                academic: {
                  first: 23857,
                  last: 24221,
                  gap: 244,
                },
                professional: {
                  first: 24209,
                  last: 24310,
                  gap: 35,
                },
                volunteer: {},
                keywords: [],
              },
            },
            current_job_title: 'chauffeur bestelauto',
            recent_job_titles: 'chauffeur bestelauto bakwagenchauffeur regionaal transport',
            past_job_titles:
              'reachtruckchauffeur monteur computerbekabeling Magazijnmedewerker Magazijnmedewerker Magazijnmedewerker reachtruckchauffeur monsternemer (industrie)',
            insights: [
              {
                createdAt: '2025-11-05T12:20:19.451Z',
                newValue: {
                  role: 'reachtruckchauffeur',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'schenker db',
                  },
                  dates: {
                    start: {
                      month: 5,
                      year: 2017,
                    },
                    end: {
                      month: 12,
                      year: 2017,
                    },
                  },
                },
                _id: '690b41039038b017b6452f63',
                oldValue: null,
                candidateId: 6918318,
                type: 'jobs.added',
                platform: 'werknl',
              },
              {
                createdAt: '2024-04-29T11:55:12.768Z',
                newValue: {
                  role: 'reachtruckchauffeur',
                  employment_hours: 40,
                  description: null,
                  company: {
                    name: 'schenker db',
                  },
                  dates: {
                    start: {
                      month: 5,
                      year: 2017,
                    },
                    end: {
                      month: 12,
                      year: 2017,
                    },
                  },
                },
                _id: '662f8aa02cd0e125e39da727',
                oldValue: null,
                candidateId: 6918318,
                type: 'jobs.added',
                platform: 'werknl',
              },
              {
                createdAt: '2022-10-13T02:56:50.351Z',
                newValue: null,
                _id: '63477e72c1ef717d96cfbfd4',
                oldValue: null,
                candidateId: 6918318,
                type: 'candidate.added',
                platform: 'werknl',
              },
            ],
            last_insight_date: '2025-11-05T12:20:19.451Z',
            new_candidate_date: '2022-10-13T02:56:50.351Z',
          },
          sort: [0, 1762345219451],
          last_matched_date: null,
          actions: [],
          is_unlocked: false,
          reasons: [],
          distance_to_commute: {
            bike: {
              distance_km: 14,
              duration_minutes: 47,
            },
            driving: {
              distance_km: 14,
              duration_minutes: 19,
            },
          },
        } as CandidateDto,
      ],
    },
  },
  tenant_id: 2512,
  tenant_domain: 'ROBIN',
  name: 'Logistiek Medewerker - Pernis',
  vacancy_document_identifier: null,
  vacancy_url_or_name: null,
  is_ats_configured: null,
  ats_name: 'AI - Logistiek Medewerker',
  ats_id: 'aAdMxay0Q8w-NA8d',
  created_at: '2025-11-07T16:51:20.671770Z',
  updated_at: '2025-11-07T17:12:10.909169Z',
  status: 'active',
  legacy_assigment_id: 351321,
  result_callback_url: null,
  ai_text:
    'Job Title: AI - Logistiek Medewerker City: Pernis Job Description: Wil jij werken als logistiek medewerker bij een toonaangevende wereldwijde producent van innovatieve materialen? Voor een internationale speler in de chemische industrie in Pernis zoeken we een ervaren logistiek medewerker. Je werkt in een professionele omgeving waar jouw precisie en SAP-kennis als logistiek medewerker het verschil maken!\n€2500 - €3500\nSalaris\n32 - 40 uur\nPer week\nLOD02776\nVacaturenummer\nPernis\nLocatie\nLBO, MBO\nOpleidingsniveau\nLogistiek\nBranche\nZo ziet jouw werkdag eruit\nAls logistiek medewerker ben je verantwoordelijk voor het beheer van het magazijn op een moderne productielocatie. Je zorgt voor een efficiënte goederenstroom en bent de spil tussen productie en voorraad.\nDit zijn jouw belangrijkste taken als logistiek medewerker:\n\nInboeken en uitboeken van goederen in SAP\nBeheren van spare parts en PBM\'s \nUitvoeren van cycle counts \nVerzorgen van magazijnadministratie \nOnderhouden van voorraadlocaties volgens 5S \nSamenwerken met engineers en productie\nWaarborgen van veiligheidsvoorschriften\n\nDit krijg je van ons\nBij Logistiek24 geloven we dat jij het verschil maakt. We zorgen daarom goed voor onze mensen en bieden je:\n\nSalaris van € 17,31 bruto per uur (afhankelijk van ervaring) \nBij wederzijdse tevredenheid mogelijkheid op overname opdrachtgever\nPensioenregeling via STIPP\nReiskostenvergoeding\nEen vast contactpersoon die altijd voor je klaarstaa\n\nDit breng je mee\n\nLBO+/MBO werk- en denkniveau in logistiek\nMinimaal 1 jaar magazijnervaring \nErvaring met SAP\nUitstekende beheersing van de Nederlandse taal (alleen Engels is niet voldoende)\nVCA certificaat (verplicht) \nHeftruckcertificaat of bereid deze te halen \nVOG kunnen aanvragen \nAccuraat en veiligheidsbewust\n\nWerktijden \n\nFulltime\nDagdienst (07.00 - 15.00 uur)\nMaandag t/m vrijdag\n\nKennismaken met Logistiek24?\nBij Logistiek24 draait alles om jou! Als specialist in logistiek kijken we verder dan alleen je ervaring. We denken mee over je ontwikkeling en wat het beste bij jouw leven past. We hebben dagelijks contact met de beste werkgevers en weten precies wat er speelt.\nDus wat we ook allemaal van je vragen, we zullen altijd beginnen met... "Wat zou jij willen?"\nZin in een kop koffie en een goed gesprek? Bel of app ons op 010-2600 180, of kom langs op het Rivium in Capelle aan den IJssel!',
  origin: 'ats',
  created_by: 16125,
  modified_by: 16125,
} as BestMatchesDto;
